/* UbraTech — guided Setup Finder (modern light rebuild)
   Same guided architecture as before — data-driven FLOWS per goal, branching
   questions, progress rail, animated result with matched shortlist + plain-English
   reasoning + tap-to-change chips + ink/toner lookup — restyled onto the light
   "Clear + Signal" surfaces, with real product cards and two new departments
   (Build & upgrade · Home & lifestyle). Self-contained: bundles its own icon
   set. Hydrates real products from finder-products.json. Persists to localStorage.
   Honours prefers-reduced-motion + mobile.
*/
(function(){
  const root=document.getElementById('finderx');
  if(!root) return;
  const useTiles=document.getElementById('use-tiles');
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* -------- bundled icons (self-contained; matches theme IC set) -------- */
  const IC={
    laptop:'<rect x="3" y="4" width="18" height="12" rx="2"/><path d="M2 20h20"/>',
    book:'<path d="M4 4h11a3 3 0 0 1 3 3v13a2 2 0 0 0-2-2H4z"/><path d="M4 4v14"/>',
    game:'<rect x="2" y="7" width="20" height="11" rx="4"/><path d="M7 12h3M8.5 10.5v3M15 11h.01M18 13h.01"/>',
    building:'<rect x="4" y="3" width="16" height="18" rx="1"/><path d="M9 8h.01M15 8h.01M9 12h.01M15 12h.01M9 16h6"/>',
    cam:'<path d="M2 8h13v9H2z"/><path d="M15 11l6-3v8l-6-3"/><circle cx="7" cy="12.5" r="2"/>',
    home:'<path d="M3 11l9-8 9 8"/><path d="M5 10v10h14V10"/>',
    desktop:'<rect x="3" y="4" width="18" height="12" rx="1"/><path d="M9 20h6M12 16v4"/>',
    monitor:'<rect x="2" y="4" width="20" height="13" rx="2"/><path d="M8 21h8M12 17v4"/>',
    wifi:'<path d="M5 12.5a10 10 0 0 1 14 0M8 15.5a6 6 0 0 1 8 0"/><circle cx="12" cy="19" r="1"/>',
    drive:'<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M7 9h10M7 13h6"/><circle cx="17" cy="14" r="1"/>',
    print:'<path d="M6 9V3h12v6"/><rect x="4" y="9" width="16" height="8" rx="1"/><path d="M8 17h8v4H8z"/>',
    doc:'<rect x="5" y="3" width="14" height="18" rx="2"/><path d="M9 8h6M9 12h6M9 16h4"/>',
    layers:'<path d="M12 3 3 8l9 5 9-5-9-5z"/><path d="M3 12l9 5 9-5"/>',
    wand:'<path d="M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/>',
    feather:'<path d="M20 4a7 7 0 0 0-10 0L5 9v10h10l5-5a7 7 0 0 0 0-10z"/><path d="M8 16 20 4"/>',
    zap:'<path d="M13 2 3 14h7l-1 8 10-12h-7z"/>',
    sparkle:'<path d="M12 3l2 5 5 2-5 2-2 5-2-5-5-2 5-2z"/>',
    cast:'<path d="M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"/><path d="M2 12a6 6 0 0 1 6 6M2 16a2 2 0 0 1 2 2"/><circle cx="3" cy="19" r="1"/>',
    crown:'<path d="M3 7l4 4 5-6 5 6 4-4v11H3z"/>',
    tree:'<path d="M12 2 6 10h3l-4 6h5v4h4v-4h5l-4-6h3z"/>',
    globe:'<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18z"/>',
    cpu:'<rect x="6" y="6" width="12" height="12" rx="1"/><path d="M9 2v2M15 2v2M9 20v2M15 20v2M2 9h2M2 15h2M20 9h2M20 15h2"/>',
    ram:'<rect x="2" y="8" width="20" height="9" rx="1"/><path d="M6 8v9M10 8v9M14 8v9M18 8v9M4 20h4M16 20h4"/>',
    tag:'<path d="M20 12l-8 8-9-9V3h8z"/><circle cx="7.5" cy="7.5" r="1.5"/>',
    plug:'<path d="M9 2v6M15 2v6M6 8h12v3a6 6 0 0 1-12 0z"/><path d="M12 17v5"/>',
    speaker:'<rect x="6" y="3" width="12" height="18" rx="2"/><circle cx="12" cy="14" r="3"/><path d="M12 7h.01"/>',
    shield:'<path d="M12 2 4 5v6c0 5 3.4 8.5 8 10 4.6-1.5 8-5 8-10V5z"/>'
  };
  const I=(n)=> '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'+(IC[n]||'')+'</svg>';

  /* =====================================================================
     CONFIG — everything store-specific lives here and is overridable from
     the theme via window.UBRA_FINDER_CONFIG (set in Liquid from theme
     settings). NOTHING below is baked into logic — the fallbacks are only
     used if the theme forgets to inject a value, and links default to
     RELATIVE Shopify paths so no domain is ever hard-coded.
     Theme should inject, e.g.:
       window.UBRA_FINDER_CONFIG = {
         waNumber: "{{ settings.whatsapp_number }}",         // digits only
         baseUrl:  "",                                        // "" = relative (recommended in-theme)
         feedUrl:  "{{ 'finder-products.json' | asset_url }}",
         businessPage: "/pages/ubratech-for-business"
       };
     ===================================================================== */
  const CFG=Object.assign({
    waNumber:'27690387840',   // fallback only — set from theme settings
    baseUrl:'',               // "" = relative links (Shopify). Demo sets the live domain.
    feedUrl:'finder-products.json',
    businessPage:'/pages/ubratech-for-business'
  }, (typeof window!=='undefined'&&window.UBRA_FINDER_CONFIG)||{});

  const WA='https://wa.me/'+String(CFG.waNumber).replace(/\D/g,'');
  const link=(h)=>{
    if(!h) return CFG.baseUrl||'/';
    if(h.startsWith('#')||h.endsWith('.html')||h.indexOf('http')===0) return h;      // pass-through
    const path = h.startsWith('/') ? h : ('/collections/'+h);                        // handle -> collection
    return (CFG.baseUrl||'')+path;                                                    // relative unless baseUrl set
  };

  /* -------- goals (grouped entry) -------- */
  const GOAL={
    work:    {t:'Work laptop',        s:'Office & productivity', icon:'laptop'},
    study:   {t:'Study',              s:'School & varsity',      icon:'book'},
    home:    {t:'Home office',        s:'Desk setup & extras',   icon:'home'},
    gaming:  {t:'Gaming',             s:'Play & stream',         icon:'game'},
    components:{t:'Build & upgrade',  s:'Parts, storage & memory',icon:'cpu'},
    lifestyle:{t:'Home & lifestyle',  s:'Smart home & audio',    icon:'home'},
    ink:     {t:'Find my ink / toner',s:'Match your printer',    icon:'tag'},
    printer: {t:'Which printer?',     s:'Buy the right one',     icon:'print'},
    wifi:    {t:'Wi-Fi coverage',     s:'Mesh & access points',  icon:'wifi'},
    netgear: {t:'Switches & servers', s:'Wired network & racks', icon:'layers'},
    monitor: {t:'Find a monitor',     s:'The right screen',      icon:'monitor'},
    ups:     {t:'UPS & backup power', s:'Beat loadshedding',     icon:'zap'},
    dock:    {t:'Docking & USB-C',    s:'One-cable desk',        icon:'drive'},
    meet:    {t:'Conferencing',       s:'Webcams & video calls', icon:'cast'},
    fleet:   {t:'Business fleet',     s:'Kit out a team',        icon:'building'},
    security:{t:'Security & CCTV',    s:'Protect a home/site',   icon:'cam'}
  };
  const GROUPS=[
    {h:'Laptops & computers', g:['work','study','home']},
    {h:'Gaming',              g:['gaming']},
    {h:'Build & upgrade',     g:['components']},
    {h:'Home & lifestyle',    g:['lifestyle']},
    {h:'Print & ink',         g:['ink','printer']},
    {h:'Networking & Wi-Fi',  g:['wifi','netgear']},
    {h:'Accessories & power', g:['monitor','ups','dock','meet']},
    {h:'Business & security', g:['fleet','security']}
  ];
  const HERO=['work','gaming','components','lifestyle','security','ink'];

  const SCOPES={
    computers:  {title:'What are you setting up?', help:'Laptops, desktops & workstations — tell us the job and we\u2019ll match the power.', noun:'computer',  goals:['work','study','home']},
    accessories:{title:'What do you need?',        help:'Screens, docks, power protection and call kit — pick what you\u2019re after.',      noun:'accessory', goals:['monitor','dock','ups','meet']},
    components: {title:'Build or upgrade?',         help:'Storage, memory, graphics and power — tell us what you\u2019re adding.',           noun:'part',      goals:['components']},
    lifestyle:  {title:'Home & lifestyle',         help:'Smart home, sound and the everyday tech that makes home life easier.',            noun:'setup',     goals:['lifestyle']},
    print:      {title:'Printing & ink',           help:'Buy the right printer, or match cartridges to a printer you already own.',         noun:'match',     goals:['printer','ink']},
    networking: {title:'Network & Wi-Fi',          help:'Coverage, wired ports, servers and racks — tell us the scale.',                   noun:'setup',     goals:['wifi','netgear']},
    business:   {title:'Kitting out a team?',       help:'Fleet machines, security and infrastructure — with formal quotes.',              noun:'quote',     goals:['fleet','security','netgear']}
  };

  /* -------- flows (branch per goal) -------- */
  const FLOWS={
    work:[
      {id:'task',q:'What will you mainly do on it?',help:'Pick the closest — it sets the power you actually need, so you don\u2019t overspend.',kind:'tiles',opts:[
        {v:'everyday',t:'Everyday office',s:'Email, docs, web, video calls',icon:'doc'},
        {v:'multitask',t:'Heavy multitasking',s:'Big spreadsheets, lots of apps',icon:'layers'},
        {v:'creative',t:'Creative work',s:'Photo, video & design',icon:'wand'},
        {v:'light',t:'Light & simple',s:'Browsing & streaming',icon:'feather'}]},
      {id:'port',q:'Where will you use it most?',kind:'pills',opts:[
        {v:'move',t:'Always on the move'},{v:'mix',t:'A bit of both'},{v:'desk',t:'Mostly at a desk'}]},
      {id:'budget',q:'What\u2019s your budget?',kind:'pills',opts:[
        {v:'lo',t:'Under R10k'},{v:'mid',t:'R10k \u2013 R20k'},{v:'hi',t:'R20k +'}]}
    ],
    study:[
      {id:'task',q:'What\u2019s it mainly for?',kind:'tiles',opts:[
        {v:'everyday',t:'Notes & research',s:'Docs, web, classes',icon:'doc'},
        {v:'multitask',t:'Projects & coding',s:'Heavier coursework',icon:'layers'},
        {v:'creative',t:'Design & media',s:'Art, video, editing',icon:'wand'},
        {v:'light',t:'The basics',s:'Browsing & streaming',icon:'feather'}]},
      {id:'port',q:'How often will you carry it?',kind:'pills',opts:[
        {v:'move',t:'Every day'},{v:'mix',t:'Sometimes'},{v:'desk',t:'Stays home'}]},
      {id:'budget',q:'Budget?',kind:'pills',opts:[
        {v:'lo',t:'Under R8k'},{v:'mid',t:'R8k \u2013 R15k'},{v:'hi',t:'R15k +'}]}
    ],
    home:[
      {id:'task',q:'What do you need most?',kind:'tiles',opts:[
        {v:'everyday',t:'A reliable laptop',s:'Work-from-home basics',icon:'doc'},
        {v:'multitask',t:'A powerful machine',s:'For a permanent desk',icon:'layers'},
        {v:'creative',t:'Creative power',s:'Photo, video & design',icon:'wand'},
        {v:'light',t:'Just the essentials',s:'Browsing & admin',icon:'feather'}]},
      {id:'port',q:'Laptop or desktop?',kind:'pills',opts:[
        {v:'move',t:'Laptop'},{v:'desk',t:'Desktop'},{v:'mix',t:'Not sure yet'}]},
      {id:'budget',q:'Budget?',kind:'pills',opts:[
        {v:'lo',t:'Under R10k'},{v:'mid',t:'R10k \u2013 R20k'},{v:'hi',t:'R20k +'}]}
    ],
    gaming:[
      {id:'res',q:'How do you want to play?',help:'This drives the graphics card — the part that matters most for gaming.',kind:'tiles',opts:[
        {v:'1080',t:'1080p, high FPS',s:'Fast & competitive',icon:'zap'},
        {v:'1440',t:'1440p, ultra detail',s:'Best-looking single-player',icon:'sparkle'},
        {v:'stream',t:'Play & stream',s:'Gaming + broadcasting',icon:'cast'}]},
      {id:'form',q:'Desktop or laptop?',kind:'pills',opts:[
        {v:'desktop',t:'Desktop rig'},{v:'laptop',t:'Gaming laptop'}]},
      {id:'budget',q:'Budget?',kind:'pills',opts:[
        {v:'lo',t:'Under R20k'},{v:'mid',t:'R20k \u2013 R35k'},{v:'hi',t:'R35k +'}]}
    ],
    components:[
      {id:'part',q:'What are you adding or upgrading?',help:'We\u2019ll point you at genuine, compatible parts — and help you fit them if you\u2019re unsure.',kind:'tiles',opts:[
        {v:'storage',t:'Storage',s:'SSDs, hard drives & NVMe',icon:'drive'},
        {v:'memory',t:'Memory (RAM)',s:'Speed up an older machine',icon:'ram'},
        {v:'graphics',t:'Graphics card',s:'More gaming / creative power',icon:'zap'},
        {v:'power',t:'Power & cooling',s:'PSUs, fans & UPS',icon:'plug'}]},
      {id:'machine',q:'What\u2019s it going into?',kind:'pills',opts:[
        {v:'laptop',t:'A laptop'},{v:'desktop',t:'A desktop PC'},{v:'server',t:'A server / NAS'},{v:'unsure',t:'Not sure'}]}
    ],
    lifestyle:[
      {id:'area',q:'What are you setting up at home?',help:'From smart security to sound — the everyday tech that makes home life easier.',kind:'tiles',opts:[
        {v:'smart',t:'Smart home',s:'Plugs, cameras & sensors',icon:'shield'},
        {v:'audio',t:'Sound & audio',s:'Speakers & headphones',icon:'speaker'},
        {v:'everyday',t:'Everyday tech',s:'Chargers, cables & power',icon:'plug'},
        {v:'comfort',t:'Home-office comfort',s:'Keyboards, mice & webcams',icon:'doc'}]},
      {id:'budget',q:'Roughly what are you spending?',kind:'pills',opts:[
        {v:'lo',t:'Keep it low'},{v:'mid',t:'Mid-range'},{v:'hi',t:'Best I can get'}]}
    ],
    fleet:[
      {id:'size',q:'How many people are you kitting out?',kind:'pills',opts:[
        {v:'s',t:'1 \u2013 5'},{v:'m',t:'6 \u2013 20'},{v:'l',t:'20 +'}]},
      {id:'users',q:'What kind of users?',kind:'tiles',opts:[
        {v:'basic',t:'Everyday staff',s:'Office & admin',icon:'doc'},
        {v:'pro',t:'Power users',s:'Engineering, design, dev',icon:'layers'},
        {v:'exec',t:'Executives',s:'Premium · Apple / Surface',icon:'crown'}]},
      {id:'budget',q:'Rough budget per machine?',kind:'pills',opts:[
        {v:'lo',t:'Under R10k'},{v:'mid',t:'R10k \u2013 R18k'},{v:'hi',t:'R18k +'}]}
    ],
    security:[
      {id:'cams',q:'How many cameras do you need?',help:'A rough number is fine — we\u2019ll match the kit and recorder.',kind:'pills',opts:[
        {v:'2',t:'2 \u2013 4'},{v:'6',t:'5 \u2013 8'},{v:'9',t:'9 +'}]},
      {id:'camtype',q:'What type of cameras?',help:'Analogue cameras use coaxial cable and connect to a DVR. IP cameras use Cat5/6 cable and connect to an NVR \u2014 the two types can\u2019t be mixed on the same recorder.',kind:'tiles',opts:[
        {v:'analogue',t:'Analogue (TurboHD)',s:'Coaxial cable \u00b7 DVR required',icon:'plug'},
        {v:'ip',t:'IP (Network)',s:'Cat5/6 \u00b7 PoE \u00b7 NVR required',icon:'wifi'}]},
      {id:'env',q:'Where are they going?',kind:'tiles',opts:[
        {v:'in',t:'Mostly indoors',s:'Home or office interior',icon:'home'},
        {v:'out',t:'Mostly outdoors',s:'Perimeter & entrances',icon:'tree'},
        {v:'both',t:'A bit of both',s:'Full property coverage',icon:'globe'}]},
      {id:'days',q:'How long should footage be kept?',kind:'pills',opts:[
        {v:'7',t:'About a week'},{v:'30',t:'About a month'},{v:'plus',t:'Longer / project'}]}
    ],
    printer:[
      {id:'use',q:'What will you mainly print?',help:'This points us at inkjet vs laser, and colour vs mono.',kind:'tiles',opts:[
        {v:'docs',t:'Documents & text',s:'Home & office paperwork',icon:'doc'},
        {v:'photo',t:'Photos & rich colour',s:'Vibrant colour output',icon:'wand'},
        {v:'volume',t:'High volume',s:'A busy office',icon:'layers'},
        {v:'labels',t:'Labels & specialist',s:'Shipping, barcodes',icon:'tag'}]},
      {id:'tech',q:'Any preference on technology?',kind:'pills',opts:[
        {v:'laser',t:'Laser (fast, sharp text)'},{v:'inkjet',t:'Ink-tank (cheap colour)'},{v:'either',t:'Not sure'}]},
      {id:'aio',q:'Do you need to scan & copy too?',kind:'pills',opts:[
        {v:'aio',t:'Yes — all-in-one'},{v:'print',t:'Just printing'}]}
    ],
    wifi:[
      {id:'size',q:'How big is the space?',help:'A rough idea is fine — it sets how many units you need.',kind:'tiles',opts:[
        {v:'flat',t:'Flat / small home',s:'1\u20132 bedrooms',icon:'home'},
        {v:'house',t:'Average house',s:'3\u20134 rooms, maybe double-storey',icon:'building'},
        {v:'large',t:'Large or multi-storey',s:'Big home or office',icon:'globe'}]},
      {id:'load',q:'What\u2019s happening on the network?',kind:'pills',opts:[
        {v:'light',t:'Browsing & email'},{v:'stream',t:'Streaming & calls'},{v:'heavy',t:'Many devices / WFH'}]},
      {id:'wire',q:'Can you run a network cable?',kind:'pills',opts:[
        {v:'no',t:'No — go wireless'},{v:'yes',t:'Yes, I can cable'},{v:'unsure',t:'Not sure'}]}
    ],
    netgear:[
      {id:'need',q:'What do you need?',kind:'tiles',opts:[
        {v:'switch',t:'A network switch',s:'More wired ports',icon:'layers'},
        {v:'server',t:'Server hardware',s:'Compute & storage',icon:'drive'},
        {v:'rack',t:'Cabinet or rack',s:'House the equipment',icon:'building'}]},
      {id:'scale',q:'What scale?',kind:'pills',opts:[
        {v:'sm',t:'Small office'},{v:'md',t:'Growing business'},{v:'lg',t:'Enterprise / project'}]}
    ],
    monitor:[
      {id:'use',q:'What will you use it for?',kind:'tiles',opts:[
        {v:'office',t:'Office & everyday',s:'Docs, web, calls',icon:'doc'},
        {v:'creative',t:'Design & photo',s:'Colour-accurate work',icon:'wand'},
        {v:'gaming',t:'Gaming',s:'High refresh rate',icon:'zap'},
        {v:'multi',t:'Productivity / WFH',s:'Lots of windows',icon:'layers'}]},
      {id:'size',q:'What size feels right?',kind:'pills',opts:[
        {v:'24',t:'24-inch'},{v:'27',t:'27-inch'},{v:'32',t:'32-inch / ultrawide'}]},
      {id:'budget',q:'Budget?',kind:'pills',opts:[
        {v:'lo',t:'Under R3k'},{v:'mid',t:'R3k \u2013 R6k'},{v:'hi',t:'R6k +'}]}
    ],
    ups:[
      {id:'gear',q:'What must it keep running?',help:'This sets the capacity (VA) you need — loadshedding sorted.',kind:'tiles',opts:[
        {v:'router',t:'Router / Wi-Fi only',s:'Stay online through dips',icon:'wifi'},
        {v:'desk',t:'A desktop PC',s:'PC plus a monitor',icon:'desktop'},
        {v:'multi',t:'Several devices',s:'PC, screens & network',icon:'layers'},
        {v:'server',t:'Server / rack',s:'Critical equipment',icon:'drive'}]},
      {id:'runtime',q:'How long should it hold?',kind:'pills',opts:[
        {v:'short',t:'Ride out dips'},{v:'med',t:'30\u201360 minutes'},{v:'long',t:'As long as possible'}]}
    ],
    dock:[
      {id:'laptop',q:'What are you connecting?',kind:'tiles',opts:[
        {v:'usbc',t:'A modern laptop',s:'Charges through a small oval USB-C port',icon:'laptop'},
        {v:'mac',t:'A MacBook',s:'macOS',icon:'laptop'},
        {v:'legacy',t:'Older / USB-A only',s:'No USB-C port',icon:'layers'}]},
      {id:'screens',q:'How many external screens?',kind:'pills',opts:[
        {v:'1',t:'One'},{v:'2',t:'Two'},{v:'3',t:'Three +'}]}
    ],
    meet:[
      {id:'room',q:'Where do the calls happen?',kind:'tiles',opts:[
        {v:'desk',t:'At my desk',s:'A personal setup',icon:'desktop'},
        {v:'huddle',t:'A small meeting room',s:'2\u20135 people',icon:'building'},
        {v:'board',t:'A boardroom',s:'A large room',icon:'globe'}]},
      {id:'need',q:'What matters most?',kind:'pills',opts:[
        {v:'video',t:'Great video'},{v:'audio',t:'Clear audio'},{v:'both',t:'Both'}]}
    ]
  };

  /* -------- placeholder product pools (hydrated by the live feed) -------- */
  const LAPTOPS={
    entry:[{brand:'HP',title:'250 G10',spec:'Core i5 · 16GB · 512GB SSD · 15.6\u2033',price:'R10 499'},
           {brand:'Dell',title:'Inspiron 15 3530',spec:'Core i5 · 16GB · 512GB SSD',price:'R11 999'},
           {brand:'Lenovo',title:'IdeaPad Slim 3',spec:'Core i5 · 8GB · 512GB SSD',price:'R9 799'}],
    mid:[{brand:'Lenovo',title:'ThinkPad E14',spec:'Core i5 · 16GB · 512GB SSD · 14\u2033',price:'R15 999'},
         {brand:'Dell',title:'Inspiron 14 Plus',spec:'Core i7 · 16GB · 512GB SSD',price:'R17 999'},
         {brand:'HP',title:'Pavilion Plus 14',spec:'Core i7 · 16GB · 1TB SSD',price:'R18 999'}],
    high:[{brand:'Dell',title:'XPS 14',spec:'Core i7 · 16GB · 1TB SSD',price:'R32 999'},
          {brand:'HP',title:'Spectre x360 14',spec:'Core i7 · 16GB · 1TB SSD',price:'R29 999'},
          {brand:'Lenovo',title:'ThinkPad X1 Carbon',spec:'Core i7 · 32GB · 1TB SSD',price:'R38 999'}],
    creator:[{brand:'Lenovo',title:'ThinkPad P14s',spec:'Core i7 · 32GB · 1TB · RTX',price:'R41 999'},
             {brand:'Dell',title:'XPS 15',spec:'Core i7 · 32GB · 1TB · RTX 4050',price:'R44 999'},
             {brand:'ASUS',title:'ProArt Studiobook',spec:'Core i9 · 32GB · 1TB · RTX',price:'R52 999'}]
  };
  const DESKTOP={
    entry:[{brand:'Dell',title:'Vostro Tower',spec:'Core i5 · 16GB · 512GB SSD',price:'R11 999'},
           {brand:'HP',title:'ProDesk SFF',spec:'Core i5 · 16GB · 512GB SSD',price:'R12 999'}],
    mid:[{brand:'Dell',title:'OptiPlex Tower',spec:'Core i7 · 16GB · 512GB SSD',price:'R16 999'},
         {brand:'HP',title:'ProDesk 400 G9',spec:'Core i7 · 16GB · 1TB SSD',price:'R18 499'}],
    high:[{brand:'Dell',title:'OptiPlex Plus',spec:'Core i7 · 32GB · 1TB SSD',price:'R24 999'},
          {brand:'HP',title:'Elite Tower 800',spec:'Core i7 · 32GB · 1TB SSD',price:'R26 999'}],
    creator:[{brand:'Dell',title:'Precision Workstation',spec:'Core i9 · 32GB · 1TB · Pro GPU',price:'R44 999'}]
  };
  const GAMING={
    entry:[{brand:'ASUS',title:'TUF Gaming F15',spec:'Core i5 · RTX 4050 · 16GB',price:'R21 999'},
           {brand:'Dell',title:'G15',spec:'Core i7 · RTX 4060 · 16GB',price:'R26 999'}],
    ultra:[{brand:'ASUS',title:'ROG Strix G16',spec:'Core i7 · RTX 4070 · 16GB',price:'R38 999'},
           {brand:'Dell',title:'Alienware m16',spec:'Core i7 · RTX 4070 · 32GB',price:'R46 999'}],
    desktop:[{brand:'Dell',title:'Alienware Aurora',spec:'Core i7 · RTX 4070 · 32GB',price:'R42 999'},
             {brand:'ASUS',title:'ROG Strix GT15',spec:'Core i7 · RTX 4070 · 32GB',price:'R39 999'}]
  };
  /* Filled from the live feed (ip_small/ip_medium/ip_large for IP, small/medium/
     large for analogue). Deliberately empty here: if the feed fails to load the
     Finder offers a quote rather than inventing a kit we may not stock. */
  const CCTV={ip_small:[],ip_medium:[],ip_large:[],small:[],medium:[],large:[]};
  /* Matched recorders and drives — HAND-PICKED from manufacturer specs (13 Oct
     2026), never inferred from the feed. Prices and stock are read live from the
     product when the result is shown.
       DS-7104NI-Q1/4P   4 ch · 4 PoE ports · 1 SATA up to 6TB · records up to 6MP
       DS-7108NI-Q1/8P   8 ch · 8 PoE ports · 1 SATA up to 6TB
       DS-7616NXI-K2/16P 16 ch · 16 PoE ports · 2 SATA      (project answer → quote)
       DS-7108HGHI-M1-T  8 ch TurboHD DVR (analogue)        (no one-click kit)
       IDS-7116HQHI-M1/T 16 ch TurboHD DVR (analogue)
       Seagate SkyHawk   surveillance-grade drives, 2TB / 4TB (within the 6TB bay limit) */
  const RECORDERS={
    analogue:{
      small: {brand:'Hikvision',title:'8-Channel TurboHD DVR',spec:'For analogue cameras · H.265+',url:'/products/hikvision-8-channel-1080p-lite-mini-1u-dvr'},
      medium:{brand:'Hikvision',title:'8-Channel TurboHD DVR',spec:'For analogue cameras · H.265+',url:'/products/hikvision-8-channel-1080p-lite-mini-1u-dvr'},
      large: {brand:'Hikvision',title:'16-Channel AcuSense TurboHD DVR',spec:'For analogue cameras · AcuSense',url:'/products/hikvision-16-channel-1080p-acusense-mini-1u-dvr'}
    },
    ip:{
      small: {brand:'Hikvision',title:'4-Channel PoE NVR',spec:'4 PoE ports power the cameras · 1 drive bay',url:'/products/hikvision-4-channel-1u-mini-nvr'},
      medium:{brand:'Hikvision',title:'8-Channel PoE NVR',spec:'8 PoE ports power the cameras · 1 drive bay',url:'/products/hikvision-8-channel-1u-mini-nvr'},
      large: {brand:'Hikvision',title:'16-Channel AcuSense PoE NVR',spec:'16 PoE ports · 2 drive bays',url:'/products/hikvision-16-channel-acusense-nvr-ds-7616nxi-k2-16p'}
    }
  };
  const DRIVES={
    '2TB':{brand:'Seagate',title:'SkyHawk 2TB Surveillance Drive',spec:'Built to record 24/7',url:'/products/seagate-skyhawk-surveillance-2tb-3-5-sata-internal-hdd'},
    '4TB':{brand:'Seagate',title:'SkyHawk 4TB Surveillance Drive',spec:'Built to record 24/7',url:'/products/seagate-skyhawk-surveillance-4tb-3-5-sata-internal-hdd'}
  };
  /* One-click kits only where the pairing is verified: Hikvision fixed IP cameras
     (DS-2CD, up to 4MP so the NVR records them at full resolution) on a Hikvision
     PoE NVR of the right size. */
  const KIT_CAMS={small:4,medium:8};
  /* "Complete your setup" add-ons (13 Oct 2026). Universal items only - nothing
     that has to fit a particular model. Prices, photos and stock are read live. */
  const ADDON={
    m365p:{brand:'Microsoft',title:'Microsoft 365 Personal (1 year)',spec:'Word, Excel, Outlook · 1 person',url:'/products/microsoft-esd-m365-personal-subscript-product-key-license'},
    m365f:{brand:'Microsoft',title:'Microsoft 365 Family (1 year)',spec:'Up to 6 people',url:'/products/microsoft-esd-m365-family-subscript-product-key-license'},
    m365b:{brand:'Microsoft',title:'Microsoft 365 Business Standard (1 year)',spec:'Office apps + business email',url:'/products/microsoft-365-business-standard-esd-1-year-subscription'},
    mouse:{brand:'Logitech',title:'Logitech M171 Wireless Mouse',spec:'Plug-and-play USB receiver',url:'/products/logitech-m171-black-compact-portable-wireless-mouse'},
    bag:{brand:'Targus',title:'Targus CitySmart Multi-Fit Laptop Bag',spec:'Fits 14\u2033 to 15.6\u2033 laptops',url:'/products/targus-citysmart-advanced-multi-fit-14-15-6-laptop-topload-black-grey'},
    combo:{brand:'HP',title:'HP 330 Wireless Keyboard & Mouse',spec:'Wireless combo',url:'/products/hp-330-black-wireless-keyboard-mouse-combo'},
    ups:{brand:'APC',title:'APC Back-UPS 750VA',spec:'Rides through short outages · safe shutdown',url:'/products/apc-backup-ups-750va-410w-ups-tower-rack-mount-included-no-rack'}
  };
  /* Wired Wi-Fi kit — hand-picked 13 Oct 2026. TP-Link Omada ceiling access points
     (standard 802.3af/at PoE, so any PoE+ switch powers them) and a PoE+ switch
     sized so EVERY access point could draw the 802.3at maximum (25.5W) at once:
       Cudy GS1005P     4 PoE+ ports · 60W  budget  -> up to 2 access points
       TP-Link TL-SG1008MP 8 PoE+ ports · 153W budget -> up to 6 access points
     (budgets from the TP-Link product page and the Cudy listing). The EAP110 is left
     out on purpose: it takes passive 24V PoE, not the standard. */
  const AP_CHOICES=[
    {brand:'TP-Link Omada',title:'TP-Link EAP650 AX3000 Wi-Fi 6 Ceiling Access Point',spec:'Wi-Fi 6 · AX3000 · PoE',url:'/products/tp-link-ax3000-dual-band-ceiling-mount-access-point'},
    {brand:'TP-Link Omada',title:'TP-Link EAP620 HD AX1800 Wi-Fi 6 Ceiling Access Point',spec:'Wi-Fi 6 · AX1800 · PoE',url:'/products/tp-link-ax1800-dual-band-wireless-ceiling-mount-access-point'},
    {brand:'TP-Link Omada',title:'TP-Link EAP223 AC1350 Ceiling Access Point',spec:'Wi-Fi 5 · AC1350 · PoE · budget',url:'/products/tp-link-ac1350-wireless-mu-mimo-gigabit-ceiling-mount-access-point'}
  ];
  const POE_SWITCH={
    small:{brand:'Cudy',title:'Cudy 5-Port Gigabit PoE+ Switch (4 PoE+ ports)',spec:'Powers up to 2 access points',url:'/products/cudy-5-port-gigabit-poe-unmanaged-switch'},
    large:{brand:'TP-Link',title:'TP-Link 8-Port Gigabit PoE+ Switch (TL-SG1008MP)',spec:'Powers up to 6 access points',url:'/products/tp-link-8-port-gigabit-unmanaged-rackmount-poe-switch'}
  };
  const PRINTERS={
    docs:[{brand:'HP',title:'LaserJet M111w',spec:'Mono laser · Wi-Fi',price:'R2 199'},
          {brand:'Brother',title:'HL-L2400DW',spec:'Mono laser · duplex · Wi-Fi',price:'R3 499'}],
    photo:[{brand:'Epson',title:'EcoTank L3250',spec:'Colour ink-tank · Wi-Fi',price:'R4 999'},
           {brand:'Canon',title:'PIXMA G3420',spec:'Colour ink-tank · Wi-Fi',price:'R4 299'}],
    volume:[{brand:'HP',title:'LaserJet Pro MFP M428fdw',spec:'Mono laser AIO · high volume',price:'R7 999'},
            {brand:'Brother',title:'MFC-L2820DW',spec:'Mono laser all-in-one',price:'R5 499'}],
    labels:[{brand:'Brother',title:'QL-820NWB Label Printer',spec:'Thermal label · Wi-Fi',price:'R3 299'}]
  };
  const MONITORS={
    office:[{brand:'Dell',title:'P2422H 24\u2033 FHD',spec:'IPS · 75Hz · height-adjust',price:'R3 299'},
            {brand:'Samsung',title:'27\u2033 ViewFinity S6 QHD',spec:'IPS · USB-C',price:'R5 799'}],
    creative:[{brand:'Dell',title:'U2723QE 27\u2033 4K',spec:'IPS Black · USB-C hub',price:'R11 999'},
              {brand:'BenQ',title:'PD2705U 27\u2033 4K',spec:'Factory-calibrated · designer',price:'R10 499'}],
    gaming:[{brand:'Samsung',title:'Odyssey G5 27\u2033 QHD',spec:'165Hz · 1ms · curved',price:'R6 299'},
            {brand:'LG',title:'UltraGear 27\u2033 QHD',spec:'165Hz · IPS · G-Sync',price:'R6 999'}],
    multi:[{brand:'Dell',title:'P2422H 24\u2033 FHD',spec:'Thin bezel · height-adjust',price:'R3 299'},
           {brand:'HP',title:'E24 G5 24\u2033 FHD',spec:'IPS · USB hub · ergonomic',price:'R3 899'}]
  };
  const UPS={
    router:[{brand:'RCT',title:'Mini-UPS DC Router Backup',spec:'Silent · hours of Wi-Fi',price:'R699'},
            {brand:'Mecer',title:'650VA Line-Interactive UPS',spec:'~390W · router + ONT',price:'R899'}],
    desk:[{brand:'Mecer',title:'1200VA UPS',spec:'~720W · PC + monitor',price:'R1 699'},
          {brand:'APC',title:'Back-UPS 1400VA',spec:'~700W · AVR',price:'R2 999'}],
    multi:[{brand:'Mecer',title:'2000VA UPS',spec:'~1200W · desk + network',price:'R2 699'},
           {brand:'APC',title:'Back-UPS Pro 2200VA',spec:'~1320W · LCD · AVR',price:'R5 499'}],
    server:[{brand:'APC',title:'Smart-UPS 3000VA Rackmount',spec:'Pure sine · managed',price:'R14 999'}]
  };
  const MESH={
    flat:[{brand:'TP-Link',title:'Deco X20 (2-pack)',spec:'AX1800 mesh · ~185m²',price:'R2 799'}],
    house:[{brand:'TP-Link',title:'Deco X50 (3-pack)',spec:'AX3000 mesh · ~370m²',price:'R4 999'},
           {brand:'TP-Link',title:'Deco X20 (3-pack)',spec:'AX1800 mesh · ~230m²',price:'R3 799'}],
    large:[{brand:'TP-Link',title:'Deco X50 (3-pack) + node',spec:'AX3000 · whole-property',price:'R5 999'}]
  };
  const WIFI_AP=[{brand:'Ubiquiti',title:'UniFi U6+ Access Point',spec:'Wi-Fi 6 · PoE · ceiling',price:'R1 999'},
                 {brand:'TP-Link',title:'8-Port PoE Switch',spec:'Powers the access points',price:'R1 499'}];
  const NETGEAR={
    switch:[{brand:'TP-Link',title:'TL-SG108 8-Port Gigabit',spec:'Unmanaged · desktop',price:'R549'},
            {brand:'TP-Link',title:'TL-SG1024 24-Port Gigabit',spec:'Rackmount',price:'R2 199'}],
    server:[{brand:'HPE',title:'ProLiant ML30 Gen11',spec:'Tower server · Xeon E',price:'From R24 999'},
            {brand:'Dell',title:'PowerEdge T150',spec:'Tower server',price:'From R21 999'}],
    rack:[{brand:'UbraTech',title:'12U Wall-mount Cabinet',spec:'Lockable · vented',price:'R2 499'},
          {brand:'UbraTech',title:'27U Floor-standing Rack',spec:'Server cabinet',price:'R6 999'}]
  };
  const DOCK={
    usbc:[{brand:'Lenovo',title:'USB-C Dock Gen2',spec:'Dual display · PD · Ethernet',price:'R2 899'},
          {brand:'Dell',title:'WD19S 130W Dock',spec:'USB-C · dual 4K',price:'R3 499'}],
    mac:[{brand:'Anker',title:'575 USB-C Dock',spec:'Thunderbolt · dual 4K · Mac',price:'R3 999'}],
    legacy:[{brand:'Targus',title:'DV4K USB-A Docking Station',spec:'Dual HDMI · USB-A & C',price:'R2 499'}]
  };
  /* no static picks: an empty feed pool routes to a quote, never to a made-up price */
  const MEET={desk:[],huddle:[],board:[]};
  /* new departments — curated placeholders until the sync supplies feeds */
  const COMPONENTS={
    storage:[{brand:'Samsung',title:'980 1TB NVMe SSD',spec:'PCIe · big speed boost',price:'R1 199'},
             {brand:'Kingston',title:'NV2 500GB NVMe SSD',spec:'Fast, affordable upgrade',price:'R649'},
             {brand:'Seagate',title:'BarraCuda 2TB HDD',spec:'Bulk storage',price:'R899'}],
    memory:[{brand:'Kingston',title:'FURY 16GB DDR4 Kit',spec:'2×8GB · 3200MHz',price:'R899'},
            {brand:'Crucial',title:'16GB DDR4 SODIMM',spec:'Laptop memory',price:'R749'},
            {brand:'Corsair',title:'Vengeance 32GB DDR5',spec:'2×16GB · desktop',price:'R2 299'}],
    graphics:[{brand:"ASUS",title:"TUF Gaming RTX 5060",spec:"8GB \xB7 1080p/1440p gaming",price:"R10 247",url:"/products/asus-tuf-gaming-geforce-rtx-5060-8gb-gddr7-oc-edition-graphics-card",image:"https://cdn.shopify.com/s/files/1/0666/6505/4304/files/TUF-RTX5060-O8G_ASUS-TUF-Gaming-GeForce-RTX-5060-8GB-GDDR7-OC-Edition-Graphics-Card_wr_01.jpg?v=1784132209"},{brand:"ASUS",title:"Dual RTX 5060 Ti",spec:"16GB \xB7 1440p/4K gaming",price:"R15 360",url:"/products/asus-dual-geforce-rtx-5060-ti-oc-edition-16gb-gddr7-graphics-card",image:"https://cdn.shopify.com/s/files/1/0666/6505/4304/files/DUAL-RTX5060TI-O16G-WR-01.jpg?v=1784131892"}],
    power:[{brand:'Corsair',title:'RM750e 750W PSU',spec:'80+ Gold · modular',price:'R1 899'},
           {brand:'Noctua',title:'NH-U12S CPU Cooler',spec:'Quiet, effective cooling',price:'R1 199'},
           {brand:'RCT',title:'Mini-UPS Router Backup',spec:'Keeps you online',price:'R699'}]
  };
  const LIFESTYLE={
    smart:[{brand:'TP-Link',title:'Tapo Smart Plug (2-pack)',spec:'App & voice control',price:'R399'},
           {brand:'TP-Link',title:'Tapo C210 Indoor Camera',spec:'Pan/tilt · 2K · night vision',price:'R549'},
           {brand:'Hikvision',title:'Video Doorbell',spec:'See & talk to visitors',price:'R1 499'}],
    audio:[{brand:'JBL',title:'Flip 6 Bluetooth Speaker',spec:'Portable · waterproof',price:'R1 999'},
           {brand:'Logitech',title:'Zone Vibe 100 Headset',spec:'Wireless · clear calls',price:'R2 999'}],
    everyday:[{brand:'Anker',title:'65W USB-C Charger',spec:'Charges laptop & phone',price:'R699'},
              {brand:'Ugreen',title:'USB-C Cable Set',spec:'Braided · fast charge',price:'R249'},
              {brand:'Belkin',title:'Surge Protector 6-way',spec:'Protects your gear',price:'R399'}],
    comfort:[{brand:'Logitech',title:'MK540 Wireless Combo',spec:'Keyboard & mouse',price:'R899'},
             {brand:'Logitech',title:'Brio 100 Webcam',spec:'Full-HD · great for calls',price:'R699'},
             {brand:'HP',title:'320 USB Webcam',spec:'Sharp video for meetings',price:'R502'}]
  };

  /* -------- live feed hydration -------- */
  const POOLS={laptops:LAPTOPS,desktop:DESKTOP,gaming:GAMING,monitors:MONITORS,ups:UPS,
               mesh:MESH,printers:PRINTERS,cctv:CCTV,dock:DOCK,meet:MEET,netgear:NETGEAR,
               components:COMPONENTS,lifestyle:LIFESTYLE};
  /* "You'll also need" — CATEGORY-level only, never model-level. A feed cannot
     tell you that this bracket fits that camera, but it is true of every PoE
     camera that it needs somewhere to record and a switch that supplies power.
     Each entry is [title, note, url]; url may be empty, in which case the note
     is shown without a link. Filled from the feed's `companions` block. */
  const COMPANIONS={};
  const cesc=(v)=>String(v==null?'':v).replace(/[&<>"']/g,function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});
  function companionKey(){
    switch(st.use){
      case 'work': case 'study': case 'fleet': return 'laptops';
      case 'home':     return st.ans.port==='desk'?'desktop':'laptops';
      case 'security': return 'cctv';
      case 'printer':  return 'printers';
      case 'monitor':  return 'monitors';
      case 'wifi':     return (st.ans.wire==='yes'||(st.ans.size==='large'&&st.ans.load==='heavy'))?'wifi_ap':'mesh';
      case 'netgear':  return 'netgear';
      case 'meet':     return 'meet';
      case 'components': return 'components';
      default: return null;
    }
  }
  function companionHTML(){
    try{
      const k=companionKey(); if(!k) return '';
      const list=COMPANIONS[k]; if(!Array.isArray(list)||!list.length) return '';
      const items=list.slice(0,4).map(function(c){
        const t=cesc(c[0]||''), note=cesc(c[1]||''), href=String(c[2]||'').trim();
        return href
          ? '<a class="fxr-comp-i" href="'+link(href)+'"><span class="fxr-comp-t">'+t+' '+arrIcon+'</span><span class="fxr-comp-n">'+note+'</span></a>'
          : '<div class="fxr-comp-i is-plain"><span class="fxr-comp-t">'+t+'</span><span class="fxr-comp-n">'+note+'</span></div>';
      }).join('');
      return '<div class="fxr-sub">Worth thinking about</div><div class="fxr-comp">'+items+'</div>';
    }catch(e){ return ''; }
  }

  function hydrate(feed){
    if(!feed||typeof feed!=='object') return;
    try{
      Object.keys(POOLS).forEach(function(k){
        const src=feed[k]; if(!src||typeof src!=='object') return;
        const pool=POOLS[k];
        Object.keys(src).forEach(function(b){ if(Array.isArray(src[b])&&src[b].length) pool[b]=src[b]; });
      });
      if(Array.isArray(feed.wifi_ap)&&feed.wifi_ap.length){ WIFI_AP.length=0; feed.wifi_ap.forEach(function(x){WIFI_AP.push(x);}); }
      if(feed.companions&&typeof feed.companions==='object'){
        Object.keys(feed.companions).forEach(function(k){
          if(Array.isArray(feed.companions[k])) COMPANIONS[k]=feed.companions[k];
        });
      }
    }catch(e){}
  }
  (function loadFeed(){
    try{
      const url=(typeof window!=='undefined'&&window.UBRA_FINDER_PRODUCTS_URL)||CFG.feedUrl;
      if(typeof fetch!=='function') return;
      fetch(url,{cache:'no-cache'}).then(function(r){return r.ok?r.json():null;}).then(hydrate).catch(function(){});
    }catch(e){}
  })();

  /* Ink & toner by printer — 13 Oct 2026.
     Which cartridge fits which printer is MANUFACTURER knowledge, chosen by hand and
     then matched to the product we actually stock (never inferred from feed titles).
     Only brands we sell: HP, Canon, Lexmark. Epson and Brother were removed because
     we do not stock their consumables. Prices and stock are read live from each
     product when the result is shown, so nothing here goes stale. */
  const INK={
   "HP": {
    "DeskJet (cartridge)": {
     "DeskJet 2710 / 2720 / 4120 (HP 305)": [
      {
       "n": "HP 305 Tri-colour",
       "url": "/products/hp-305-tri-color-original-ink-cartridge-hp-2720-4120"
      },
      {
       "n": "HP 305XL Black (high yield)",
       "url": "/products/hp-305xl-high-yield-black-original-ink-cartridge-hp-2720-4120"
      },
      {
       "n": "HP 305XL Tri-colour (high yield)",
       "url": "/products/hp-305xl-high-yield-tri-color-original-ink-cartridge-hp-2720-4120"
      }
     ],
     "DeskJet Ink Advantage 1115 / 2135 / 3635 / 3835 (HP 652)": [
      {
       "n": "HP 652 Black",
       "url": "/products/hp-652-black-ink-cartridge-ink-advantage-3835"
      },
      {
       "n": "HP 652 Tri-colour",
       "url": "/products/hp-652-tri-colour-original-ink-cartridge"
      }
     ],
     "DeskJet Plus Ink Advantage 6075 / 6475 (HP 653)": [
      {
       "n": "HP 653 Black",
       "url": "/products/hp-653-black-original-ink-advantage-cartridge"
      },
      {
       "n": "HP 653 Tri-colour",
       "url": "/products/hp-653-tri-color-original-ink-advantage-cartridge"
      }
     ],
     "DeskJet Ink Advantage 1015 / 1515 / 2515 / 2545 / 3515 (HP 650)": [
      {
       "n": "HP 650 Black",
       "url": "/products/hp-650-black-original-ink-cartridge"
      },
      {
       "n": "HP 650 Tri-colour",
       "url": "/products/hp-650-tri-color-ink-cartridge"
      }
     ],
     "DeskJet Ink Advantage 5575 / 5645 (HP 651)": [
      {
       "n": "HP 651 Black",
       "url": "/products/hp-651-black-ink-cartridge-ia-5575-5645"
      },
      {
       "n": "HP 651 Tri-colour",
       "url": "/products/hp-651-tri-colour-ink-cartridge-ia-55"
      }
     ],
     "DeskJet 2130 / 2630 / 3630 (HP 123)": [
      {
       "n": "HP 123 Black",
       "url": "/products/hp-123-black-original-ink-cartridge"
      }
     ]
    },
    "OfficeJet / OfficeJet Pro": {
     "OfficeJet 8012 / 8013 / 8014 & OfficeJet Pro 8022 / 8023 / 8024 / 8025 (HP 912)": [
      {
       "n": "HP 912 Black",
       "url": "/products/hp-912-black-original-ink-cartridge"
      },
      {
       "n": "HP 912 Magenta",
       "url": "/products/hp-912-magenta-original-ink-cartridge"
      },
      {
       "n": "HP 912 Yellow",
       "url": "/products/hp-912-yellow-original-ink-cartridge"
      },
      {
       "n": "HP 912XL Black",
       "url": "/products/hp-912xl-high-yield-black-original-ink-cartridge"
      },
      {
       "n": "HP 912XL Cyan",
       "url": "/products/hp-912xl-high-yield-cyan-original-ink-cartridge"
      },
      {
       "n": "HP 912XL Magenta",
       "url": "/products/hp-912xl-high-yield-magenta-original-ink-cartridge"
      },
      {
       "n": "HP 912XL Yellow",
       "url": "/products/hp-912xl-high-yield-yellow-original-ink-cartridge"
      }
     ],
     "OfficeJet Pro 9010 / 9012 / 9013 / 9020 / 9023 (HP 963)": [
      {
       "n": "HP 963 Black",
       "url": "/products/hp-963-black-original-ink-cartridge"
      },
      {
       "n": "HP 963 Cyan",
       "url": "/products/hp-963-cyan-original-ink-cartridge"
      },
      {
       "n": "HP 963 Magenta",
       "url": "/products/hp-963-magenta-original-ink-cartridge"
      },
      {
       "n": "HP 963 Yellow",
       "url": "/products/hp-963-yellow-original-ink-cartridge"
      },
      {
       "n": "HP 963XL Black",
       "url": "/products/hp-963xl-high-yield-black-original-ink-cartridge"
      },
      {
       "n": "HP 963XL Cyan",
       "url": "/products/hp-963xl-high-yield-cyan-original-ink-cartridge"
      },
      {
       "n": "HP 963XL Magenta",
       "url": "/products/hp-963xl-high-yield-magenta-original-ink-cartridge"
      },
      {
       "n": "HP 963XL Yellow",
       "url": "/products/hp-963xl-high-yield-yellow-original-ink-cartridge"
      }
     ],
     "OfficeJet 6950 / OfficeJet Pro 6960 / 6970 (HP 903)": [
      {
       "n": "HP 903 Black",
       "url": "/products/hp-903-black-original-ink-cartridge"
      },
      {
       "n": "HP 903 Cyan",
       "url": "/products/hp-903-cyan-original-ink-cartridge"
      },
      {
       "n": "HP 903 Magenta",
       "url": "/products/hp-903-magenta-original-ink-cartridge"
      },
      {
       "n": "HP 903 Yellow",
       "url": "/products/hp-903-yellow-original-ink-cartridge"
      },
      {
       "n": "HP 903XL Black",
       "url": "/products/hp-903xl-high-yield-black-original-ink-cartridge"
      },
      {
       "n": "HP 903XL Cyan",
       "url": "/products/hp-903xl-high-yield-cyan-original-ink-cartridge"
      },
      {
       "n": "HP 903XL Magenta",
       "url": "/products/hp-903xl-high-yield-magenta-original-ink-cartridge"
      },
      {
       "n": "HP 903XL Yellow",
       "url": "/products/hp-903xl-high-yield-yellow-original-ink-cartridge"
      }
     ],
     "OfficeJet Pro 7720 / 7740 / 8210 / 8710 / 8720 / 8730 (HP 953)": [
      {
       "n": "HP 953 Black",
       "url": "/products/hp-953-black-original-ink-cartridge"
      },
      {
       "n": "HP 953 Cyan",
       "url": "/products/hp-953-cyan-original-ink-cartridge"
      },
      {
       "n": "HP 953 Magenta",
       "url": "/products/hp-953-magenta-original-ink-cartridge"
      },
      {
       "n": "HP 953 Yellow",
       "url": "/products/hp-953-yellow-original-ink-cartridge"
      },
      {
       "n": "HP 953XL Black",
       "url": "/products/hp-953xl-high-yield-black-original-ink-cartridge"
      },
      {
       "n": "HP 953XL Cyan",
       "url": "/products/hp-953xl-high-yield-cyan-original-ink-cartridge"
      },
      {
       "n": "HP 953XL Magenta",
       "url": "/products/hp-953xl-high-yield-magenta-original-ink-cartridge"
      },
      {
       "n": "HP 953XL Yellow",
       "url": "/products/hp-953xl-high-yield-yellow-original-ink-cartridge"
      }
     ],
     "OfficeJet Pro 8120e / 8122 / 8123 / 8124 / 8125 / 8130e / 8132 / 8135 (HP 925)": [
      {
       "n": "HP 925 Black",
       "url": "/products/hp-925-black-original-ink-cartridge"
      },
      {
       "n": "HP 925 Cyan",
       "url": "/products/hp-925-cyan-original-ink-cartridge"
      },
      {
       "n": "HP 925 Magenta",
       "url": "/products/hp-925-magenta-original-ink-cartridge"
      },
      {
       "n": "HP 925 Yellow",
       "url": "/products/hp-925-yellow-original-ink-cartridge"
      },
      {
       "n": "HP 925e EvoMore Black",
       "url": "/products/hp-925e-evomore-black-original-ink-cartridge"
      },
      {
       "n": "HP 925e EvoMore Cyan",
       "url": "/products/hp-925e-evomore-cyan-original-ink-cartridge"
      },
      {
       "n": "HP 925e EvoMore Magenta",
       "url": "/products/hp-925e-evomore-magenta-original-ink-cartridge"
      },
      {
       "n": "HP 925e EvoMore Yellow",
       "url": "/products/hp-925e-evomore-yellow-original-ink-cartridge"
      }
     ],
     "OfficeJet Pro 9110b / 9122 / 9125 / 9720 (HP 938)": [
      {
       "n": "HP 938 Black",
       "url": "/products/hp-938-black-original-ink-cartridge"
      },
      {
       "n": "HP 938 Cyan",
       "url": "/products/hp-938-cyan-original-ink-cartridge"
      },
      {
       "n": "HP 938 Magenta",
       "url": "/products/hp-938-magenta-original-ink-cartridge"
      },
      {
       "n": "HP 938 Yellow",
       "url": "/products/hp-938-yellow-original-ink-cartridge"
      },
      {
       "n": "HP 938e EvoMore Black",
       "url": "/products/hp-938e-evomore-black-original-ink-cartridge"
      },
      {
       "n": "HP 938e EvoMore Cyan",
       "url": "/products/hp-938e-evomore-cyan-original-ink-cartridge"
      },
      {
       "n": "HP 938e EvoMore Yellow",
       "url": "/products/hp-938e-evomore-yellow-original-ink-cartridge"
      }
     ]
    },
    "Ink Tank / Smart Tank": {
     "Ink Tank 315 / 415 & Smart Tank 515 / 615 (GT53 / GT52)": [
      {
       "n": "HP GT53XL Black bottle",
       "url": "/products/hp-gt53xl-135ml-black-original-ink-bottle"
      },
      {
       "n": "HP GT52 Cyan bottle",
       "url": "/products/hp-gt52-cyan-original-ink-bottle"
      },
      {
       "n": "HP GT52 Magenta bottle",
       "url": "/products/hp-gt52-magenta-original-ink-bottle"
      },
      {
       "n": "HP GT52 Yellow bottle",
       "url": "/products/hp-gt52-yellow-original-ink-bottle"
      }
     ]
    },
    "Colour LaserJet (toner)": {
     "Color LaserJet Pro M454 / MFP M479 (HP 415A)": [
      {
       "n": "HP 415A Black",
       "url": "/products/hp-415-black-laserjet-toner-cartridge"
      },
      {
       "n": "HP 415A Cyan",
       "url": "/products/hp-415-cyan-laserjet-toner-cartridge"
      },
      {
       "n": "HP 415A Magenta",
       "url": "/products/hp-415-magenta-laserjet-toner-cartridge"
      },
      {
       "n": "HP 415A Yellow",
       "url": "/products/hp-415-yellow-laserjet-toner-cartridge"
      }
     ],
     "Color LaserJet Pro MFP M476 (HP 312A)": [
      {
       "n": "HP 312A Black",
       "url": "/products/hp-312a-black-toner-cartridge"
      },
      {
       "n": "HP 312A Cyan",
       "url": "/products/hp-312a-cyan-toner-cartridge"
      },
      {
       "n": "HP 312A Magenta",
       "url": "/products/hp-312a-magenta-toner-cartridge"
      }
     ],
     "Color LaserJet Pro M452 / MFP M477 (HP 410A)": [
      {
       "n": "HP 410A Black",
       "url": "/products/hp-410a-black-laserjet-m452-mfp-m477-toner-cartridge"
      }
     ]
    },
    "LaserJet (mono toner)": {
     "LaserJet Enterprise M507 / MFP M528 (HP 89A)": [
      {
       "n": "HP 89A Black",
       "url": "/products/hp-89a-black-laserjet-toner-cartridge"
      }
     ],
     "LaserJet Enterprise M607 / M608 / M609 / MFP M631-M633 (HP 37A)": [
      {
       "n": "HP 37A Black",
       "url": "/products/hp-37a-black-original-laserjet-toner"
      },
      {
       "n": "HP 37X Black (high yield)",
       "url": "/products/hp-37x-high-yield-black-original-laserjet-toner"
      }
     ],
     "LaserJet P3015 / Pro M521 / M525 (HP 55A)": [
      {
       "n": "HP 55A Black",
       "url": "/products/hp-55a-black-toner-cartridge"
      },
      {
       "n": "HP 55X Black (high yield)",
       "url": "/products/hp-55x-hc-black-toner-cartridge"
      }
     ]
    }
   },
   "Canon": {
    "PIXMA (cartridge)": {
     "PIXMA MG2440 / MG2540 / MG2940 / TS3140 / TS3340 / TS3440 (PG-445 / CL-446)": [
      {
       "n": "Canon PG-445 Black",
       "url": "/products/canon-pg-445-cartridge"
      },
      {
       "n": "Canon PG-445XL Black",
       "url": "/products/canon-pg-445-xl-cartridge"
      },
      {
       "n": "Canon CL-446 Colour",
       "url": "/products/canon-cl-446-cartridge"
      },
      {
       "n": "Canon CL-446XL Colour",
       "url": "/products/canon-cl-446-xl-cartridge"
      }
     ],
     "PIXMA MG2140 / MG3140 / MG3240 / MG3540 / MG4240 / MX374 / MX434 (PG-440 / CL-441)": [
      {
       "n": "Canon PG-440 Black",
       "url": "/products/canon-pg-440-ink-cartridge"
      },
      {
       "n": "Canon PG-440XL Black",
       "url": "/products/canon-pg-440-xl-ink-cartridge"
      },
      {
       "n": "Canon CL-441 Colour",
       "url": "/products/canon-cl-441-ink-cartridge"
      },
      {
       "n": "Canon CL-441XL Colour",
       "url": "/products/canon-cl-441-xl-ink-cartridge"
      }
     ],
     "PIXMA iP2700 / MP240 / MP250 / MP270 / MP280 / MX320 / MX340 / MX360 / MX410 / MX420 (PG-510 / PG-512 / CL-513)": [
      {
       "n": "Canon PG-510 Black",
       "url": "/products/canon-ink-pg-510-bk-ip2700-mp230-mp240-mp250-mp270-mp280-mp230-mx320-mx330-mx340-mx350-mx360-mx410-mx420-yield-220"
      },
      {
       "n": "Canon PG-512 Black (high yield)",
       "url": "/products/canon-ink-cartridge-pg-512-bk-black-ip2700-mp240-mp250-mp270"
      },
      {
       "n": "Canon CL-513 Colour (high yield)",
       "url": "/products/canon-ink-cl-513-clr-ip2700-mp240-mp250-mp270-mp280-mx320-mx330-mx340-mx350-mx360-mx410-mx420-yield-349"
      }
     ]
    },
    "PIXMA G (ink tank)": {
     "G1400 / G2400 / G3400 / G4400 (GI-490)": [
      {
       "n": "Canon GI-490 Black bottle",
       "url": "/products/canon-ink-gi-490-bk-g1400-g1410-g1411-g2400-g2410-g2411-g3400-g3410-g3411-g4400-g4410-g4411-yield-6-000"
      },
      {
       "n": "Canon GI-490 Cyan bottle",
       "url": "/products/canon-ink-gi-490-c-g1400-g1410-g1411-g2400-g2410-g2411-g3400-g3410-g3411-g4400-g4410-g4411-yield-7-000"
      },
      {
       "n": "Canon GI-490 Magenta bottle",
       "url": "/products/canon-ink-gi-490-m-g1400-g1410-g1411-g2400-g2410-g2411-g3400-g3410-g3411-g4400-g4410-g4411-yield-7-000"
      }
     ],
     "G1420 / G2420 / G2430 / G2470 / G3420 / G3430 / G3470 (GI-41)": [
      {
       "n": "Canon GI-41 Black bottle",
       "url": "/products/canon-ink-gi-41-bk-g1420-g2420-g2430-g2470-g3420-g3430-g3470-yield-of-6-000"
      },
      {
       "n": "Canon GI-41 Cyan bottle",
       "url": "/products/canon-ink-gi-41-c-g1420-g2420-g2430-g2470-g3420-g3430-g3470-yield-of-7-700"
      },
      {
       "n": "Canon GI-41 Magenta bottle",
       "url": "/products/canon-ink-gi-41-m-g1420-g2420-g2430-g2470-g3420-g3430-g3470-yield-of-7-700"
      },
      {
       "n": "Canon GI-41 Yellow bottle",
       "url": "/products/canon-ink-gi-41-y-g1420-g2420-g2430-g2470-g3420-g3430-g3470-yield-of-7-700"
      }
     ],
     "G5040 / G6040 / GM2040 (GI-40)": [
      {
       "n": "Canon GI-40 Black bottle",
       "url": "/products/canon-ink-gi-40-bk-gm2040-g5040-g6040-yield-6000"
      },
      {
       "n": "Canon GI-40 Cyan bottle",
       "url": "/products/canon-ink-gi-40-c-gm2040-g5040-g6040-yield-7-700"
      },
      {
       "n": "Canon GI-40 Magenta bottle",
       "url": "/products/canon-ink-gi-40-m-gm2040-g5040-g6040-yield-7-700"
      },
      {
       "n": "Canon GI-40 Yellow bottle",
       "url": "/products/canon-ink-gi-40-y-gm2040-g5040-g6040-yield-7-700"
      }
     ]
    },
    "MAXIFY": {
     "MAXIFY MB2040 / MB2140 / MB2340 / MB2740 (PGI-1400XL)": [
      {
       "n": "Canon PGI-1400XL Black",
       "url": "/products/canon-ink-pgi-1400xl-bk-mb2040-mb2140-mb2340-mb2740-yield-1200"
      },
      {
       "n": "Canon PGI-1400XL Cyan",
       "url": "/products/canon-ink-pgi-1400xl-c-mb2040-mb2140-mb2340-mb2740-yield-900"
      },
      {
       "n": "Canon PGI-1400XL Magenta",
       "url": "/products/canon-ink-pgi-1400xl-m-mb2040-mb2140-mb2340-mb2740-yield-900"
      },
      {
       "n": "Canon PGI-1400XL Yellow",
       "url": "/products/canon-ink-pgi-1400xl-y-mb2040-mb2140-mb2340-mb2740-yield-900"
      }
     ],
     "MAXIFY iB4040 / iB4140 / MB5040 / MB5140 / MB5340 / MB5440 (PGI-2400XL)": [
      {
       "n": "Canon PGI-2400XL Black",
       "url": "/products/canon-ink-pgi-2400xl-bk-ib4040-ib4140-mb5040-mb5140-mb5340-mb5440-yield-2500"
      },
      {
       "n": "Canon PGI-2400XL Cyan",
       "url": "/products/canon-ink-pgi-2400xl-c-ib4040-ib4140-mb5040-mb5140-mb5340-mb5440-yield-1500"
      },
      {
       "n": "Canon PGI-2400XL Magenta",
       "url": "/products/canon-ink-pgi-2400xl-m-ib4040-ib4140-mb5040-mb5140-mb5340-mb5440-yield-1500"
      },
      {
       "n": "Canon PGI-2400XL Yellow",
       "url": "/products/canon-ink-pgi-2400xl-y-ib4040-ib4140-mb5040-mb5140-mb5340-mb5440-yield-1500"
      }
     ]
    },
    "i-SENSYS (toner)": {
     "i-SENSYS MF211 / MF212w / MF216n / MF217w / MF226dn / MF229dw / MF231 / MF232w / MF237w / MF247dw / MF249dw (CRG 737)": [
      {
       "n": "Canon CRG 737 Black toner",
       "url": "/products/canon-toner-crg-737-bk-mf211-mf212w-mf216n-mf217w-mf226dn-mf229dw-mf231-mf232w-mf237w-mf247dw-mf249dw-yield-2-400"
      }
     ],
     "i-SENSYS MF272dw / MF275dw (CRG 071)": [
      {
       "n": "Canon CRG 071 Black toner",
       "url": "/products/canon-toner-crg-071-mf275-yield-1200"
      }
     ]
    }
   },
   "Lexmark": {
    "Mono laser (toner)": {
     "MS310 / MS410 / MS510 / MS610 (505H / 505X)": [
      {
       "n": "Lexmark 505H Black (high yield)",
       "url": "/products/lexmark-505he-cartridge"
      },
      {
       "n": "Lexmark 505X Black (extra high yield)",
       "url": "/products/lexmark-505xe-cartridge"
      }
     ],
     "MX310 / MX410 / MX510 / MX610 (605)": [
      {
       "n": "Lexmark 605 Black",
       "url": "/products/lexmark-605-black-cartridge"
      }
     ],
     "MS317 / MS417 / MS517 / MS617 / MX317 / MX417 / MX517 / MX617 (51B5000)": [
      {
       "n": "Lexmark 51B5000 Black",
       "url": "/products/lexmark-ms-mx-317-417-517-617-black-return-program-toner-cartridge"
      }
     ],
     "MS321 / MS421 / MS521 / MS621 / MX321 / MX421 / MX521 / MX522 / MX622 (56F5000)": [
      {
       "n": "Lexmark 56F5000 Black",
       "url": "/products/lexmark-black-return-program-toner-cartridge"
      }
     ],
     "MS431 / MX431 (55B5X0E)": [
      {
       "n": "Lexmark 55B5X0E Black (extra high yield)",
       "url": "/products/lexmark-ms-mx431-corp-20k-crtg"
      }
     ]
    }
   }
  };
  const INK_INDEX=[];
  Object.keys(INK).forEach(function(b){Object.keys(INK[b]).forEach(function(r){Object.keys(INK[b][r]).forEach(function(m){INK_INDEX.push({brand:b,range:r,model:m,label:b+' '+m});});});});

  const TIERH={entry:'Essential laptop',mid:'Business-class laptop',high:'Premium ultrabook',creator:'Creator laptop'};
  const TIERSPEC={
    entry:['Everyday performance','SSD storage','Full warranty'],
    mid:['Business-class','SSD storage','Full warranty'],
    high:['Premium build','Fast SSD','Full warranty'],
    creator:['Dedicated graphics','Fast SSD','Full warranty']
  };
  /* Spec chips must describe what is actually shown. Taken from the first
     product's own spec line; the generic list only if the feed gave nothing. */
  function specsFrom(pool,fallback){
    try{
      const sp=(pool&&pool[0]&&pool[0].spec)||'';
      const bits=sp.split(' \u00b7 ').map(function(x){return x.trim();}).filter(function(x){return x&&x.length<28;});
      if(bits.length>=2) return bits.slice(0,3).concat(['Genuine & warrantied']);
    }catch(e){}
    return ['Genuine stock','Full warranty','Ready to ship'];
  }
  /* A camera goes in a one-click kit only if it is a Hikvision fixed IP camera
     of 4MP or less (the Q1 NVRs record those at full resolution) and enough are
     in stock for the kit. */
  function kitCamOK(p){
    const t=String((p&&p.title)||'');
    const mp=(t.match(/(\d+)\s*MP\b/i)||[])[1];
    if(!mp||+mp>4) return false;
    return /hikvision/i.test((p.brand||'')+' '+t);
  }
  function laptopTier(a){
    if(a.task==='creative')return 'creator';
    if(a.budget==='hi')return 'high';
    if(a.budget==='mid'||a.task==='multitask')return 'mid';
    return 'entry';
  }

  function buildResult(use,a){
    if(use==='work'||use==='study'||use==='home'){
      const tier=laptopTier(a);
      const desktop=(use==='home'&&a.port==='desk');
      const pool=(desktop?DESKTOP:LAPTOPS)[tier]||LAPTOPS[tier];
      const heading=desktop?({entry:'Everyday desktop PC',mid:'Performance desktop PC',high:'Premium desktop PC',creator:'Creator workstation'})[tier]:TIERH[tier];
      const taskMap={everyday:'everyday work',multitask:'heavy multitasking',creative:'creative work',light:'light, simple use'};
      const portMap={move:'carry it everywhere',mix:'move between home and the office',desk:'keep it on a desk'};
      let reason=`Because you\u2019re after <b>${taskMap[a.task]||'general use'}</b>`;
      if(a.port&&portMap[a.port])reason+=` and want to <b>${portMap[a.port]}</b>`;
      reason+=`, we\u2019ve matched you to a <b>${heading.toLowerCase()}</b> — enough power to last years, without paying for specs you won\u2019t use.`;
      const office=use==='study'?ADDON.m365p:use==='home'?ADDON.m365f:ADDON.m365b;
      const addons=desktop?[ADDON.combo,ADDON.ups,office]:[office,ADDON.mouse,ADDON.bag];
      return {heading,tagline:'Genuine, boxed & warrantied — ready to ship nationwide.',specs:specsFrom(pool,TIERSPEC[tier]),reason,items:pool.slice(0,3),addons,
        cta:{t:'See matching '+(desktop?'desktops':'laptops'),h:link(desktop?'desktops-all-in-ones':'laptops-notebooks')}};
    }
    if(use==='gaming'){
      const desktop=a.form==='desktop';
      const tier=a.res==='1080'?'entry':'ultra';
      const pool=desktop?GAMING.desktop:GAMING[tier];
      const heading=desktop?'Gaming desktop rig':(tier==='entry'?'Entry gaming laptop':'High-end gaming laptop');
      const resMap={'1080':'fast 1080p play','1440':'stunning 1440p detail',stream:'gaming while you stream'};
      const specs=specsFrom(pool,['Dedicated graphics','Fast refresh screen','Genuine & warrantied']);
      const reason=`For <b>${resMap[a.res]||'gaming'}</b> on a <b>${desktop?'desktop rig':'gaming laptop'}</b>, the graphics card matters most — that\u2019s what these are built around.`;
      return {heading,tagline:'Alienware, ROG & Performance Series — genuine & warrantied.',specs,reason,items:pool.slice(0,3),cta:{t:'See the gaming range',h:link('/pages/gaming')}};
    }
    if(use==='components'){
      const pool=(COMPONENTS[a.part]||COMPONENTS.storage).slice(0,3);
      const heading=({storage:'Storage upgrade',memory:'Memory upgrade',graphics:'Graphics upgrade',power:'Power & cooling'})[a.part];
      const partMap={storage:'more (and faster) storage',memory:'more memory',graphics:'more graphics power',power:'reliable power and cooling'};
      const machMap={laptop:'a laptop',desktop:'a desktop PC',server:'a server or NAS',unsure:'your machine'};
      const cat=({storage:'storage-memory',memory:'storage-memory',graphics:'graphics-cards',power:'ups-power'})[a.part]||'components';
      const reason=`For <b>${partMap[a.part]||'an upgrade'}</b> in <b>${machMap[a.machine]||'your machine'}</b>, these are the genuine parts we\u2019d fit ourselves. Not sure it\u2019s compatible? Send us your model and we\u2019ll confirm before you buy.`;
      return {heading,tagline:'Genuine, boxed components — with fitment advice.',specs:[({storage:'SSD / HDD',memory:'DDR4 / DDR5',graphics:'GeForce RTX',power:'PSU / cooling'})[a.part],'Genuine stock','Warrantied','Fitment help'],reason,items:pool,cta:{t:'See '+(heading.toLowerCase()),h:link(cat)},wa:true};
    }
    if(use==='lifestyle'){
      const pool=(LIFESTYLE[a.area]||LIFESTYLE.smart).slice(0,3);
      const heading=({smart:'Smart-home starter',audio:'Sound & audio',everyday:'Everyday tech',comfort:'Home-office comfort'})[a.area];
      const areaMap={smart:'a smarter, safer home',audio:'great sound at home',everyday:'the everyday tech that just works',comfort:'a comfortable home-office setup'};
      const cat=({smart:'smart-home',audio:'audio-video-streaming',everyday:'cables-docks-adapters',comfort:'mice-keyboards'})[a.area]||'smart-home';
      const reason=`For <b>${areaMap[a.area]||'home'}</b>, here\u2019s a simple, genuine starter kit — easy to set up, and everything works together. Add to it any time.`;
      return {heading,tagline:'Genuine, boxed & warrantied — easy to set up.',specs:[({smart:'App-controlled',audio:'Wireless',everyday:'Fast & safe',comfort:'Plug-and-play'})[a.area],'Genuine stock','Warrantied','Easy setup'],reason,items:pool,cta:{t:'See '+heading.toLowerCase(),h:link(cat)}};
    }
    if(use==='fleet'){
      const map={basic:['Everyday staff fleet',LAPTOPS.entry],pro:['Power-user fleet',LAPTOPS.mid],exec:['Executive fleet',LAPTOPS.high]};
      const m=map[a.users]||map.basic;
      const sizeMap={s:'1\u20135 people',m:'6\u201320 people',l:'20+ people'};
      const reason=`For <b>${sizeMap[a.size]||'your team'}</b> of <b>${({basic:'everyday staff',pro:'power users',exec:'executives'})[a.users]||'staff'}</b>, we\u2019ll put together consistent, warrantied machines at business pricing — with a formal quote.`;
      return {heading:m[0],tagline:'Trade pricing, formal quotes & volume orders.',specs:['Business-class','Consistent specs','Warranty & support','Formal quote'],reason,items:m[1].slice(0,2),
        cta:{t:'Request a fleet quote',h:link(CFG.businessPage+'#quote')},wa:true};
    }
    if(use==='security'){
      const tier=a.cams==='2'?'small':a.cams==='6'?'medium':'large';
      const isIP=(a.camtype||'analogue')==='ip';
      const pool=(isIP?CCTV['ip_'+tier]:CCTV[tier])||[];
      const recorder=RECORDERS[isIP?'ip':'analogue'][tier];
      const heading=({small:'Starter CCTV kit',medium:'Full CCTV system',large:'Project-grade CCTV'})[tier];
      const sizeGB=(a.days==='7'&&tier==='small')?'2TB':'4TB';
      const drive=DRIVES[sizeGB];
      const envMap={in:'indoor',out:'weatherproof outdoor',both:'indoor & outdoor'};
      const recType=isIP?'NVR':'DVR';
      let reason=`For <b>${({'2':'2\u20134','6':'5\u20138','9':'9+'})[a.cams]} ${envMap[a.env]||'mixed'} ${isIP?'IP':'analogue'} cameras</b>, you need the cameras, a <b>${recType}</b> to record them and a <b>surveillance hard drive</b> inside it. ${isIP?'IP cameras plug into the NVR\u2019s PoE ports, so one network cable per camera carries both picture and power.':'Analogue cameras run on coaxial cable to a DVR and each needs a 12V power supply.'}`;
      if(a.days==='plus') reason+=' For recording longer than a month, talk to us \u2014 it usually needs a bigger recorder.';
      const kit=(isIP&&KIT_CAMS[tier]&&a.days!=='plus')?{label:'Camera',n:KIT_CAMS[tier],choices:pool.filter(kitCamOK),extras:[[recorder,1],[drive,1]],note:'Cameras, recorder and drive are matched to work together. Cable runs depend on your site, so cable is chosen separately below. You can change quantities in the cart.'}:null;
      const quote=tier==='large'||!pool.length;
      const cta=quote?{t:'Request a CCTV quote',h:link(CFG.businessPage+'#quote')}:{t:'See CCTV cameras',h:link('cctv-cameras')};
      return {heading,tagline:'Hikvision \u2014 one system that works together. Genuine, boxed & warrantied.',
        specs:[({'2':'2\u20134 cameras','6':'5\u20138 cameras','9':'9+ cameras'})[a.cams],isIP?'IP cameras · PoE NVR':'Analogue · DVR',sizeGB+' surveillance drive',envMap[a.env]||'indoor / outdoor'],
        reason,items:pool.slice(0,tier==='large'?2:3),recorder,drive,kit,cta,wa:quote||!isIP};
    }
    if(use==='printer'){
      const laser=a.tech==='laser'||(a.tech==='either'&&(a.use==='docs'||a.use==='volume'));
      const useMap={docs:'mostly documents and text',photo:'photos and rich colour',volume:'high-volume printing',labels:'labels and specialist media'};
      const heading=({docs:'Document printer',photo:'Colour ink-tank printer',volume:'High-volume office printer',labels:'Label printer'})[a.use];
      let pool=(PRINTERS[a.use]||PRINTERS.docs).slice(0,2);
      const reason=`For <b>${useMap[a.use]||'general printing'}</b>${a.aio==='aio'?' with <b>scan &amp; copy</b>':''}, a <b>${laser?'laser':'ink-tank'}</b> printer is the sensible pick — ${laser?'crisp text and low cost per page':'cheap, vivid colour and refillable tanks'}.`;
      return {heading,tagline:'Genuine, boxed printers — with cartridges in stock.',specs:[laser?'Laser':'Ink-tank',a.aio==='aio'?'All-in-one':'Print-only','Wi-Fi','Genuine consumables'],reason,items:pool,cta:{t:'See printers',h:link('printers')}};
    }
    if(use==='wifi'){
      const wired=a.wire==='yes';
      const big=a.size==='large', heavy=a.load==='heavy';
      if(wired||(big&&heavy)){
        const project=big&&heavy;
        const reason=`For a <b>${({flat:'small',house:'medium',large:'large'})[a.size]} space</b> with <b>${({light:'light use',stream:'streaming & calls',heavy:'lots of devices'})[a.load]}</b>${wired?' where you can run cable':''}, hard-wired <b>access points</b> give the most reliable coverage — one per zone, powered over the network cable.`;
        const nAP=project?6:(a.size==='large'||a.load==='heavy')?4:2;
        const sw=POE_SWITCH[nAP<=2?'small':'large'];
        const kit={label:'Access point',n:nAP,choices:AP_CHOICES,extras:[[sw,1]],
          note:'Each access point plugs into the PoE switch with one network cable, which carries both data and power. Plug the switch into your router. Cable runs depend on your building, so cable is chosen separately below. You can change quantities in the cart.'};
        return {heading:project?'Whole-home Wi-Fi (bigger job)':'Wired whole-home Wi-Fi',tagline:'Rock-solid coverage, room by room.',specs:[nAP+' access points','Powered by the network cable','One network name','Follows you room to room'],
          reason:reason+` We\u2019d start with <b>${nAP} access points</b> and a switch that powers them all.`+(project?' At this size it\u2019s worth a quick chat so we can check the layout with you.':''),
          items:AP_CHOICES,kit,cta:project?{t:'Request a Wi-Fi quote',h:link(CFG.businessPage+'#quote')}:{t:'See Wi-Fi units',h:link('access-points-mesh-wifi')},wa:project};
      }
      const pool=MESH[a.size]||MESH.house;
      const reason=`For a <b>${({flat:'small home',house:'average house',large:'large property'})[a.size]}</b> with <b>${({light:'light use',stream:'streaming & calls',heavy:'many devices'})[a.load]}</b>, a <b>mesh Wi-Fi kit</b> is the easiest fix — the units talk to each other, so one name follows you around the whole place.`;
      return {heading:'Whole-home Wi-Fi kit',tagline:'Whole-home coverage, no dead spots — set up in minutes.',specs:['Mesh system','One network name','No dead spots','Set up from an app'],reason,items:pool,cta:{t:'See whole-home Wi-Fi',h:link('access-points-mesh-wifi')}};
    }
    if(use==='netgear'){
      const heading=({switch:'Network switch',server:'Server hardware',rack:'Server cabinet / rack'})[a.need];
      const pool=(NETGEAR[a.need]||NETGEAR.switch).slice(0,2);
      const big=a.scale==='lg';
      const reason=`For a <b>${({sm:'small office',md:'growing business',lg:'enterprise / project'})[a.scale]}</b>, you\u2019re after <b>${heading.toLowerCase()}</b>. ${big?'At this scale it\u2019s worth specing it as a project so it\u2019s sized right the first time.':'These fit the bill and are genuine, warrantied stock.'}`;
      const catMap={switch:'networking',server:'server-hardware',rack:'server-cabinets-racks'};
      const cta=big?{t:'Request an infrastructure quote',h:link(CFG.businessPage+'#quote')}:{t:'See '+heading.toLowerCase(),h:link(catMap[a.need])};
      return {heading,tagline:'Enterprise networking — genuine & warrantied.',specs:[({sm:'Small office',md:'Business',lg:'Enterprise'})[a.scale],'Gigabit','Rackmount-ready','Warranty'],reason,items:pool,cta,wa:big};
    }
    if(use==='monitor'){
      const pool=(MONITORS[a.use]||MONITORS.office).slice(0,2);
      const heading=({office:'Everyday office monitor',creative:'Colour-accurate monitor',gaming:'High-refresh gaming monitor',multi:'Productivity monitor'})[a.use];
      const useMap={office:'documents, web and calls',creative:'design and photo work',gaming:'gaming',multi:'lots of windows and multitasking'};
      const reason=`For <b>${useMap[a.use]}</b> at <b>${({'24':'24-inch','27':'27-inch','32':'32-inch / ultrawide'})[a.size]}</b>, these hit the sweet spot — ${a.use==='creative'?'accurate colour and sharp 4K':a.use==='gaming'?'high refresh and low latency':'crisp, comfortable screen space'}.`;
      return {heading,tagline:'Genuine panels, warrantied — ready to ship.',specs:[({'24':'24\u2033','27':'27\u2033','32':'32\u2033+'})[a.size],a.use==='gaming'?'Fast, smooth motion':'Sharp IPS screen',a.use==='creative'?'4K · true colour':'Full-HD','Adjustable stand'],reason,items:pool,cta:{t:'See monitors',h:link('monitors-displays')}};
    }
    if(use==='ups'){
      const pool=(UPS[a.gear]||UPS.desk).slice(0,2);
      const heading=({router:'Router backup (mini-UPS)',desk:'Desktop UPS',multi:'Whole-desk UPS',server:'Rackmount UPS'})[a.gear];
      const gearMap={router:'your router and fibre online',desk:'a desktop PC and monitor',multi:'a PC, screens and network gear',server:'a server or rack'};
      const cap=({router:'~400VA',desk:'~1200VA',multi:'~2000VA',server:'3000VA+'})[a.gear];
      const reason=`To keep <b>${gearMap[a.gear]}</b> running through loadshedding${a.runtime==='long'?' for as long as possible':''}, you\u2019ll want around <b>${cap}</b> of capacity. Here\u2019s what fits.`;
      return {heading,tagline:'Beat loadshedding — genuine, warrantied backup power.',specs:[cap,a.gear==='server'?'Pure sine · rackmount':'Automatic switch-over','Steadies the power (AVR)','In stock'],reason,items:pool,cta:{t:'See UPS & power',h:link('ups-power')},wa:a.gear==='server'};
    }
    if(use==='dock'){
      const pool=(DOCK[a.laptop]||DOCK.usbc).slice(0,2);
      const heading=({usbc:'USB-C docking station',mac:'MacBook / USB-C dock',legacy:'Universal USB docking station'})[a.laptop];
      const reason=`For <b>${({usbc:'a modern laptop (USB-C)',mac:'a MacBook',legacy:'an older USB laptop'})[a.laptop]}</b> driving <b>${({'1':'one screen','2':'two screens','3':'three or more screens'})[a.screens]}</b>, this dock gives you one cable to your desk — power, screens and everything plugged in, in a single connect.`;
      return {heading,tagline:'One cable to your whole desk setup.',specs:[({usbc:'USB-C',mac:'USB-C / Thunderbolt',legacy:'USB-A + C'})[a.laptop],({'1':'Single display','2':'Dual display','3':'Triple display'})[a.screens],'Charges your laptop','Wired internet port'],reason,items:pool,cta:{t:'See docks & adapters',h:link('cables-docks-adapters')}};
    }
    if(use==='meet'){
      const pool=(MEET[a.room]||[]).slice(0,2);
      const heading=({desk:'Personal conferencing kit',huddle:'Huddle-room video bar',board:'Boardroom video system'})[a.room];
      const reason=`For <b>${({desk:'calls at your desk',huddle:'a small meeting room',board:'a boardroom'})[a.room]}</b> where <b>${({video:'video quality',audio:'clear audio',both:'both video and audio'})[a.need]}</b> matters most, this is the right level of kit — no over-buying, no fuzzy calls.`;
      return {heading,tagline:'Look and sound professional on every call.',specs:[({desk:'Personal',huddle:'2\u20135 people',board:'Large room'})[a.room],a.room==='desk'?'1080p webcam':'4K camera','Built-in mic','Plug-and-play'],reason:pool.length?reason:reason+' We\u2019ll match the right system to your room and quote it for you.',items:pool,cta:pool.length?{t:'See conferencing gear',h:link('audio-video-streaming')}:{t:'Request a conferencing quote',h:link(CFG.businessPage+'#quote')},wa:a.room==='board'||!pool.length};
    }
    return {heading:'Curated picks',tagline:'',specs:[],reason:'Hand-picked genuine products that fit what you described.',items:[],cta:{t:'Browse products',h:link('/pages/consumer')}};
  }

  /* -------- local icon literals -------- */
  const backIcon='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M11 18l-6-6 6-6"/></svg>';
  const arrIcon='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  const waIcon='<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 0 0-8.5 15.2L2 22l4.9-1.4A10 10 0 1 0 12 2z"/></svg>';
  const restartIcon='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7L3 8m0-5v5h5"/></svg>';
  const editIcon='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>';
  const checkIcon='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  const searchIcon='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4-4"/></svg>';
  const compassIcon='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="m15.5 8.5-2.5 5.5-5.5 2.5 2.5-5.5z"/></svg>';

  /* -------- shell -------- */
  root.innerHTML=
    '<div class="fx-scrim" data-close></div>'+
    '<div class="fx-modal" role="dialog" aria-modal="true" aria-label="UbraTech setup finder">'+
      '<div class="fx-top">'+
        '<div class="fx-brand"><span class="fx-mark">'+compassIcon+'</span> Setup finder</div>'+
        '<div class="fx-stepno" id="fxStepno"></div>'+
        '<button class="fx-close" data-close aria-label="Close finder"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>'+
      '</div>'+
      '<div class="fx-progress" id="fxProg" role="progressbar" aria-label="Finder progress"></div>'+
      '<div class="fx-body" id="fxBody"></div>'+
      '<div class="fx-sr" id="fxLive" aria-live="polite" role="status"></div>'+
      '<div class="fx-helpbar">'+
        '<span>Not sure about anything? There\u2019s no pressure — we\u2019ll help you get it right.</span>'+
        '<a class="fx-hb-wa" href="'+WA+'">'+waIcon+' Chat to a real person</a>'+
      '</div>'+
    '</div>';
  const bodyEl=root.querySelector('#fxBody'),progEl=root.querySelector('#fxProg'),stepnoEl=root.querySelector('#fxStepno'),liveEl=root.querySelector('#fxLive');
  function announce(t){ if(liveEl) liveEl.textContent=t||''; }
  function focusFirst(sel){
    try{ const el=bodyEl.querySelector(sel||'.fx-tile,.fx-pill,.fx-sugitem,input,.btn,a.fxr-item'); if(el&&el.focus) el.focus({preventScroll:true}); }catch(e){}
  }

  let st={use:null,idx:0,ans:{},help:'some'};
  const KEY='ubra-finder-v2';
  function persist(done){try{localStorage.setItem(KEY,JSON.stringify({use:st.use,idx:st.idx,ans:st.ans,ink:st.ink,inkStep:st.inkStep,help:st.help,done:!!done}));}catch(e){}}
  function loadSaved(){try{return JSON.parse(localStorage.getItem(KEY)||'null');}catch(e){return null;}}

  function setProg(){
    if(st.use==='ink'){ setInkProg(); return; }
    const steps=st.use?FLOWS[st.use]:[];
    const total=Math.max(st.use?steps.length:1,1);
    const done=st.use&&st.idx>=steps.length;
    const filled=st.use?(done?steps.length:Math.min(st.idx,steps.length)):0;
    progEl.innerHTML=Array.from({length:total}).map((_,i)=>`<div class="sg ${i<filled?'on':''}"></div>`).join('');
    stepnoEl.textContent=!st.use?'Start':done?'Your match':('Step '+(st.idx+1)+' of '+steps.length);
  }

  function tileHTML(v,t,s,icon,picked){
    return `<button class="fx-tile ${picked?'picked':''}" data-v="${v}"><span class="tic">${I(icon)}</span><span class="tx"><span class="tt">${t}</span>${s?`<span class="ts">${s}</span>`:''}</span><span class="tck">${checkIcon}</span></button>`;
  }

  const HELP={
    full: {t:'Guide me',              s:'I\u2019m not sure what I need — help me choose', icon:'wand'},
    some: {t:'Ask me a few questions', s:'I know roughly what I\u2019m after',            icon:'doc'},
    quick:{t:'I know what I want',     s:'Take me to the right options, fast',            icon:'zap'}
  };
  function renderHelpSelect(){
    st.use=null; setProg(); stepnoEl.textContent='Start';
    const tiles=['full','some','quick'].map(v=>`<button class="fx-tile" data-help="${v}"><span class="tic">${I(HELP[v].icon)}</span><span class="tx"><span class="tt">${HELP[v].t}</span><span class="ts">${HELP[v].s}</span></span><span class="tck">${checkIcon}</span></button>`).join('');
    bodyEl.innerHTML='<div class="fx-screen">'+
      '<div class="fx-h">How would you like to shop?</div>'+
      '<div class="fx-help">There\u2019s no wrong answer, and you can change your mind at any time. We\u2019ll take it at your pace.</div>'+
      '<div class="fx-tiles">'+tiles+'</div>'+
    '</div>';
    bodyEl.querySelectorAll('[data-help]').forEach(b=>b.addEventListener('click',()=>{ st.help=b.dataset.help; persist(false); renderUseSelect(); }));
    announce('How would you like to shop? Three choices.');
    focusFirst();
  }

  function fillDefaults(){
    const steps=FLOWS[st.use]||[];
    steps.forEach(s=>{ if(st.ans[s.id]==null){ const o=s.opts[Math.floor(s.opts.length/2)]; if(o) st.ans[s.id]=o.v; } });
  }

  function renderUseSelect(){
    setProg();
    const groups=GROUPS.map(gr=>{
      const tiles=gr.g.map(v=>tileHTML(v,GOAL[v].t,GOAL[v].s,GOAL[v].icon)).join('');
      return `<div class="fxr-sub">${gr.h}</div><div class="fx-tiles">${tiles}</div>`;
    }).join('');
    bodyEl.innerHTML='<div class="fx-screen">'+
      '<div class="fx-h">What are you shopping for?</div>'+
      '<div class="fx-help">Tell us the goal, not the tech — we\u2019ll translate it into the right product and explain why.</div>'+
      groups+
      '<div class="fx-foot"><button class="fx-back" data-toramp>'+backIcon+' Back</button><span class="fx-hint">Pick a goal</span></div>'+
    '</div>';
    bind();
    const tr=bodyEl.querySelector('[data-toramp]'); if(tr) tr.addEventListener('click',renderHelpSelect);
    announce('What are you shopping for? Choose a goal.');
    focusFirst();
  }

  function renderScopeSelect(key){
    const sc=SCOPES[key]; if(!sc){ renderUseSelect(); return; }
    st={use:null,idx:0,ans:{},help:st.help,scope:key};
    setProg(); stepnoEl.textContent='Start';
    const tiles=sc.goals.map(v=>tileHTML(v,GOAL[v].t,GOAL[v].s,GOAL[v].icon)).join('');
    bodyEl.innerHTML='<div class="fx-screen">'+
      `<div class="fx-h">${sc.title}</div>`+
      `<div class="fx-help">${sc.help}</div>`+
      '<div class="fx-tiles">'+tiles+'</div>'+
      '<div class="fx-foot"><button class="fx-back" data-allgoals>'+backIcon+' See all options</button><span class="fx-hint">Pick one</span></div>'+
    '</div>';
    bind();
    const ag=bodyEl.querySelector('[data-allgoals]'); if(ag) ag.addEventListener('click',renderUseSelect);
    announce(sc.title);
    focusFirst();
  }

  function renderStep(){
    const steps=FLOWS[st.use],step=steps[st.idx];setProg();
    const sel=st.ans[step.id];
    const opts=step.kind==='tiles'
      ? '<div class="fx-tiles">'+step.opts.map(o=>tileHTML(o.v,o.t,o.s,o.icon,sel===o.v)).join('')+'</div>'
      : '<div class="fx-pills">'+step.opts.map(o=>`<button class="fx-pill ${sel===o.v?'picked':''}" data-v="${o.v}">${o.t}</button>`).join('')+'</div>';
    bodyEl.innerHTML='<div class="fx-screen">'+
      `<div class="fx-h">${step.q}</div>`+
      (step.help?`<div class="fx-help">${step.help}</div>`:'')+
      opts+
      '<div class="fx-foot"><button class="fx-back">'+backIcon+' Back</button>'+
        '<span style="display:flex;align-items:center;gap:14px">'+
          '<button class="fx-skip" data-skip>Skip to my match'+arrIcon+'</button>'+
          '<span class="fx-hint">'+(st.idx+1)+' of '+steps.length+'</span>'+
        '</span>'+
      '</div>'+
    '</div>';
    bind();
    const sk=bodyEl.querySelector('[data-skip]'); if(sk) sk.addEventListener('click',()=>{ fillDefaults(); renderResult(); });
    announce('Step '+(st.idx+1)+' of '+steps.length+'. '+step.q);
    focusFirst();
  }

  function handleOf(u){ const m=String(u||'').match(/\/products\/([^/?#]+)/); return m?m[1]:''; }
  const LIVE={};
  function liveProduct(h){
    if(!LIVE[h]) LIVE[h]=fetch('/products/'+h+'.js',{credentials:'same-origin'})
      .then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});
    return LIVE[h];
  }
  const rands=(c)=>'R'+Math.round(c/100).toLocaleString('en-ZA').replace(/,/g,'\u00a0');
  /* After a result renders: show today's price, and drop a card whose product
     has sold out since the feed was built. */
  function refreshLive(){
    bodyEl.querySelectorAll('[data-live]').forEach(function(el){
      liveProduct(el.getAttribute('data-live')).then(function(p){
        if(!p) return;
        const pp=el.querySelector('.pp'); if(pp) pp.textContent=rands(p.price);
        /* Hand-picked items (recorder, drive, switch, cartridges) carry no photo of
           their own - use the product's live featured image. */
        const pi=el.querySelector('.pi');
        if(pi&&!pi.classList.contains('has-img')&&p.featured_image){
          const src=String(p.featured_image); const sized=src+(src.indexOf('?')>-1?'&':'?')+'width=400';
          pi.querySelectorAll('.pgl,.pbw').forEach(function(n){n.remove();});
          const img=document.createElement('img'); img.src=sized; img.alt=''; img.loading='lazy';
          pi.classList.add('has-img'); pi.appendChild(img);
        }
        if(!p.available){ el.classList.add('is-gone'); const s=el.querySelector('.pstk'); if(s){s.textContent='Sold out';s.classList.add('low');} }
      });
    });
  }
  function addonsHTML(list){
    if(!list||!list.length) return '';
    return '<div class="fxr-sub">Complete your setup</div><div class="fxr-items fxr-addons">'+list.map(function(p){
      return '<div class="fxr-addon">'+productCard(Object.assign({icon:'layers'},p))+
        '<button class="btn btn-ghost fxr-add" type="button" data-add="'+handleOf(p.url)+'">Add to cart</button></div>';
    }).join('')+'</div>';
  }
  function bindAddons(){
    bodyEl.querySelectorAll('.fxr-add').forEach(function(b){
      b.addEventListener('click',function(){
        if(b.dataset.done) { location.href='/cart'; return; }
        b.disabled=true; b.textContent='Adding\u2026';
        liveProduct(b.dataset.add).then(function(p){
          if(!p||!p.available) throw 0;
          return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:p.variants[0].id,quantity:1}]})});
        }).then(function(r){ if(!r.ok) throw 0; b.disabled=false; b.dataset.done='1'; b.textContent='Added \u2713 \u00b7 View cart'; })
          .catch(function(){ b.disabled=false; b.textContent='Unavailable \u2014 ask us'; });
      });
    });
  }
  function kitHTML(k){
    if(!k||!k.choices.length) return '';
    const opts=k.choices.map(function(c,i){return '<option value="'+i+'">'+cesc(c.title)+'</option>';}).join('');
    return '<div class="fxr-sub">The complete kit</div>'+
      '<div class="fxr-kit" id="fxKit">'+
        '<label class="fxr-kit-l">'+cesc(k.label)+' <select id="fxKitCam">'+opts+'</select></label>'+
        '<div class="fxr-kit-rows" id="fxKitRows"><div class="fxr-kit-row is-wait">Checking today\u2019s prices and stock\u2026</div></div>'+
        '<div class="fxr-kit-tot"><span>Kit total</span><b id="fxKitTot">\u2014</b></div>'+
        '<button class="btn btn-orange" id="fxKitAdd" type="button" disabled>Add the whole kit to cart</button>'+
        '<p class="fxr-kit-n">'+cesc(k.note)+'</p>'+
      '</div>';
  }
  function bindKit(k){
    const sel=bodyEl.querySelector('#fxKitCam'); if(!sel) return;
    const rowsEl=bodyEl.querySelector('#fxKitRows'), totEl=bodyEl.querySelector('#fxKitTot'), btn=bodyEl.querySelector('#fxKitAdd');
    let lines=[];
    function build(){
      const main=k.choices[+sel.value||0];
      const want=[[main,k.n]].concat(k.extras);
      btn.disabled=true; totEl.textContent='\u2014';
      Promise.all(want.map(function(w){return liveProduct(handleOf(w[0].url));})).then(function(ps){
        let total=0, ok=true; lines=[];
        rowsEl.innerHTML=want.map(function(w,i){
          const p=ps[i]; const q=w[1];
          if(!p||!p.available){ ok=false; return '<div class="fxr-kit-row is-out">'+q+' \u00d7 '+cesc(w[0].title)+' <span>Out of stock</span></div>'; }
          total+=p.price*q; lines.push({id:p.variants[0].id,quantity:q});
          return '<div class="fxr-kit-row"><span>'+q+' \u00d7 '+cesc(w[0].title)+'</span><span>'+rands(p.price*q)+'</span></div>';
        }).join('');
        if(ok){ totEl.textContent=rands(total); btn.disabled=false; }
        else { totEl.textContent='Ask us'; btn.textContent='Part of this kit is out of stock \u2014 ask us on WhatsApp'; btn.disabled=false; btn.dataset.wa='1'; }
      });
    }
    sel.addEventListener('change',build); build();
    btn.addEventListener('click',function(){
      if(btn.dataset.wa){ location.href=WA; return; }
      btn.disabled=true; btn.textContent='Adding\u2026';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:lines})})
        .then(function(r){ if(!r.ok) throw 0; location.href='/cart'; })
        .catch(function(){ btn.disabled=false; btn.textContent='Could not add \u2014 tap to try again'; });
    });
  }
  function productCard(p){
    const q=(typeof p.qty==='number')?p.qty:null;
    const low=(q!==null&&q>0&&q<=5);
    const stock=q===null?'':'<span class="pstk'+(low?' low':'')+'">'+(low?('Only '+q+' left'):'In stock')+'</span>';
    const pic=p.image
      ? `<span class="pi has-img">${stock}<img src="${p.image}" alt="" loading="lazy"></span>`
      : `<span class="pi">${stock}<span class="pgl">${I(p.icon||'layers')}</span>${p.brand?`<span class="pbw">${p.brand}</span>`:''}</span>`;
    const inner=pic+`<div class="pinfo"><div class="pb">${p.brand||''}</div><div class="pt">${p.title||''}</div><div class="psp">${p.spec||''}</div><div class="prow">`+(p.url?`<span class="pp">${p.price||'\u2026'}</span>`:`<span class="pp-note">View range</span>`)+(p.url?`<span class="pgo">${arrIcon}</span>`:'')+'</div></div>';
    const h=handleOf(p.url);
    return `<a class="fxr-item is-link"${h?` data-live="${h}"`:''} href="${p.url||'/search?q='+encodeURIComponent(((p.brand||'')+' '+(p.title||'')).trim())}">${inner}</a>`;
  }

  function renderResult(){
    st.idx=(FLOWS[st.use]||[]).length;
    const r=buildResult(st.use,st.ans);setProg();persist(true);
    const steps=FLOWS[st.use]||[];
    let ic=({work:'laptop',study:'laptop',home:'desktop',gaming:'game',fleet:'building',security:'cam',printer:'print',wifi:'wifi',netgear:'layers',monitor:'monitor',ups:'zap',dock:'drive',meet:'cast'})[st.use]||'layers';
    if(st.use==='home'&&st.ans.port!=='desk') ic='laptop';
    if(st.use==='components') ic=({storage:'drive',memory:'ram',graphics:'zap',power:'plug'})[st.ans.part]||'cpu';
    if(st.use==='lifestyle') ic=({smart:'shield',audio:'speaker',everyday:'plug',comfort:'doc'})[st.ans.area]||'home';
    const chips=steps.map(s=>{const val=st.ans[s.id];if(val==null)return '';const o=s.opts.find(x=>x.v===val);return `<button data-step="${s.id}">${o?o.t:val} ${editIcon}</button>`;}).join('');
    const items=r.items.map(p=>productCard(Object.assign({icon:ic},p))).join('');
    const gridClass=r.items.length===1?'fxr-items one':r.items.length===2?'fxr-items two':'fxr-items';
    bodyEl.innerHTML='<div class="fx-screen">'+
      '<div class="fxr-badge">'+checkIcon+' Your match</div>'+
      `<div class="fxr-h" id="fxrH" tabindex="-1">${r.heading}</div>`+
      (r.tagline?`<div class="fxr-tag">${r.tagline}</div>`:'')+
      (r.specs.length?'<div class="fxr-specs">'+r.specs.map(s=>`<span>${s}</span>`).join('')+'</div>':'')+
      `<div class="fxr-reason">${r.reason}</div>`+
      (items?'<div class="fxr-sub">Top matches for you</div><div class="'+gridClass+'">'+items+'</div>':'')+
      (r.kit&&r.kit.choices.length?kitHTML(r.kit):
        ((r.recorder||r.drive)?'<div class="fxr-sub">You\u2019ll also need</div><div class="fxr-items '+(r.recorder&&r.drive?'two':'one')+'">'+(r.recorder?productCard(Object.assign({icon:'drive'},r.recorder)):'')+(r.drive?productCard(Object.assign({icon:'drive'},r.drive)):'')+'</div>':''))+
      (r.addons?addonsHTML(r.addons):companionHTML())+
      (chips?'<div class="fxr-sub">Your answers — tap to change</div><div class="fxr-answers">'+chips+'</div>':'')+
      '<div class="fxr-cta">'+
        `<a class="btn btn-orange" href="${r.cta.h}">${r.cta.t} ${arrIcon}</a>`+
        (r.wa?`<a class="btn btn-ghost" href="${WA}">${waIcon} Ask on WhatsApp</a>`:'')+
        '<button class="btn btn-ghost" id="fxRestart">'+restartIcon+' Start over</button>'+
      '</div>'+
    '</div>';
    bodyEl.querySelectorAll('.fxr-answers button').forEach(b=>b.addEventListener('click',()=>{const i=steps.findIndex(s=>s.id===b.dataset.step);if(i>=0){st.idx=i;renderStep();}}));
    const rs=bodyEl.querySelector('#fxRestart');if(rs)rs.addEventListener('click',()=>{st={use:null,idx:0,ans:{},help:st.help};try{localStorage.removeItem(KEY);}catch(e){}renderHelpSelect();});
    refreshLive(); if(r.kit) bindKit(r.kit); if(r.addons) bindAddons();
    announce('Your match: '+r.heading+'.');
    focusFirst('#fxrH');
  }

  /* -------- ink/toner guided lookup -------- */
  function setInkProg(){
    const order=['brand','range','model','result'];
    const filled=order.indexOf(st.inkStep)+ (st.inkStep==='result'?1:0);
    progEl.innerHTML=Array.from({length:3}).map((_,i)=>`<div class="sg ${i<Math.min(filled,3)?'on':''}"></div>`).join('');
    stepnoEl.textContent=st.inkStep==='result'?'Your cartridges':st.inkStep==='brand'?'Find your printer':st.inkStep==='range'?'Step 2 of 3':'Step 3 of 3';
  }
  function pillsInk(list){ return '<div class="fx-pills">'+list.map(o=>`<button class="fx-pill" data-ink="${o}">${o}</button>`).join('')+'</div>'; }
  function renderInk(){
    setInkProg();
    if(st.inkStep==='brand'){
      bodyEl.innerHTML='<div class="fx-screen">'+
        '<div class="fx-h">Find your ink or toner</div>'+
        '<div class="fx-help">Type your printer model, or pick the brand below — we\u2019ll show the exact cartridges that fit.</div>'+
        '<div class="fx-search"><span class="fx-search-ic">'+searchIcon+'</span><input id="fxInk" type="text" autocomplete="off" placeholder="e.g. HP DeskJet 2720, Epson L3250\u2026"></div>'+
        '<div id="fxInkSug" class="fx-sug"></div>'+
        '<div class="fx-or">or pick your printer brand</div>'+
        pillsInk(Object.keys(INK))+
        '<div class="fx-foot"><button class="fx-back">'+backIcon+' Back</button><span class="fx-hint">Genuine cartridges only</span></div>'+
      '</div>';
      const inp=bodyEl.querySelector('#fxInk'),sug=bodyEl.querySelector('#fxInkSug');
      inp.addEventListener('input',()=>{
        const q=inp.value.trim().toLowerCase();
        if(q.length<2){sug.innerHTML='';return;}
        const toks=q.split(/[\s,]+/).filter(Boolean);
        const hits=INK_INDEX.filter(x=>{const hay=(x.brand+' '+x.range+' '+x.model).toLowerCase();return toks.every(t=>hay.includes(t));}).slice(0,6);
        sug.innerHTML=hits.length?hits.map(h=>`<button class="fx-sugitem" data-b="${h.brand}" data-r="${h.range}" data-m="${h.model}"><span>${h.brand} <b>${h.model}</b></span><span class="sm">${h.range}</span></button>`).join(''):
          '<div class="fx-nohit">We don\u2019t have that printer in the guide yet. <a href="/search?type=product&q='+encodeURIComponent(inp.value.trim()+' ink toner')+'">Search our ink &amp; toner for \u201c'+cesc(inp.value.trim())+'\u201d</a> or <a href="'+WA+'">ask us on WhatsApp</a> \u2014 send the cartridge number from your old cartridge and we\u2019ll match it.</div>';
        sug.querySelectorAll('.fx-sugitem').forEach(b=>b.addEventListener('click',()=>{st.ink={brand:b.dataset.b,range:b.dataset.r,model:b.dataset.m};st.inkStep='result';persist(true);renderInk();}));
      });
      bindInk();
    } else if(st.inkStep==='range'){
      const ranges=Object.keys(INK[st.ink.brand]);
      bodyEl.innerHTML='<div class="fx-screen">'+
        `<div class="fx-h">Which ${st.ink.brand} range?</div>`+
        '<div class="fx-help">Pick the family your printer belongs to.</div>'+
        pillsInk(ranges)+
        '<div class="fx-foot"><button class="fx-back">'+backIcon+' Back</button><span class="fx-hint">'+st.ink.brand+'</span></div>'+
      '</div>';
      bindInk();
    } else if(st.inkStep==='model'){
      const models=Object.keys(INK[st.ink.brand][st.ink.range]);
      bodyEl.innerHTML='<div class="fx-screen">'+
        '<div class="fx-h">Which model?</div>'+
        `<div class="fx-help">${st.ink.brand} · ${st.ink.range}</div>`+
        pillsInk(models)+
        '<div class="fx-foot"><button class="fx-back">'+backIcon+' Back</button><span class="fx-hint">Step 3 of 3</span></div>'+
      '</div>';
      bindInk();
    } else {
      const carts=((INK[st.ink.brand]||{})[st.ink.range]||{})[st.ink.model]||[];
      const items=carts.map(c=>productCard({brand:c.n.split(' ')[0],title:c.n,spec:'Original '+c.n.split(' ')[0]+' \u00b7 boxed & sealed',url:c.url,image:c.image,icon:'tag'})).join('');
      const gridClass=carts.length===1?'fxr-items one':carts.length<=2?'fxr-items two':'fxr-items';
      bodyEl.innerHTML='<div class="fx-screen">'+
        '<div class="fxr-badge">'+checkIcon+' Exact match</div>'+
        `<div class="fxr-h">Cartridges for your ${st.ink.brand}</div>`+
        `<div class="fxr-tag">${st.ink.brand} ${st.ink.model}</div>`+
        `<div class="fxr-reason">These are the <b>original ${st.ink.brand}</b> cartridges made for the <b>${st.ink.model.replace(/\s*\([^)]*\)\s*$/,'')}</b>. Check the number on your old cartridge matches before you buy \u2014 if anything is unclear, send us a photo and we\u2019ll confirm.</div>`+
        '<div class="fxr-sub">Fits your printer</div><div class="'+gridClass+'">'+items+'</div>'+
        '<div class="fxr-cta">'+
          `<a class="btn btn-orange" href="${link('ink-toner')}">Shop ink &amp; toner ${arrIcon}</a>`+
          `<a class="btn btn-ghost" href="${WA}">${waIcon} Not sure? Ask us</a>`+
          '<button class="btn btn-ghost" id="fxRestart">'+restartIcon+' Start over</button>'+
        '</div>'+
      '</div>';
      const rs=bodyEl.querySelector('#fxRestart');if(rs)rs.addEventListener('click',()=>{st={use:null,idx:0,ans:{},help:st.help};try{localStorage.removeItem(KEY);}catch(e){}renderHelpSelect();});
      refreshLive();
    }
    const h=bodyEl.querySelector('.fx-h,.fxr-h'); announce(h?h.textContent:''); focusFirst();
  }
  function bindInk(){
    bodyEl.querySelectorAll('[data-ink]').forEach(b=>b.addEventListener('click',()=>{
      const v=b.dataset.ink;
      if(st.inkStep==='brand'){st.ink={brand:v};st.inkStep='range';}
      else if(st.inkStep==='range'){st.ink.range=v;st.inkStep='model';}
      else if(st.inkStep==='model'){st.ink.model=v;st.inkStep='result';persist(true);}
      renderInk();
    }));
    const back=bodyEl.querySelector('.fx-back');
    if(back)back.addEventListener('click',()=>{
      if(st.inkStep==='brand'){st={use:null,idx:0,ans:{},help:st.help};renderUseSelect();}
      else if(st.inkStep==='range'){st.inkStep='brand';renderInk();}
      else if(st.inkStep==='model'){st.inkStep='range';renderInk();}
      else {st.inkStep='model';renderInk();}
    });
  }

  function pick(v){
    const steps=FLOWS[st.use],step=steps[st.idx];st.ans[step.id]=v;persist(false);
    const el=bodyEl.querySelector('[data-v="'+v+'"]');if(el)el.classList.add('picked');
    const go=()=>{ if(st.idx>=steps.length-1)renderResult(); else {st.idx++;renderStep();} };
    reduce?go():setTimeout(go,200);
  }
  function startUse(v){
    const el=bodyEl.querySelector('[data-v="'+v+'"]');if(el)el.classList.add('picked');
    const hl=st.help||'some',sc=st.scope;
    const go=()=>{
      if(v==='ink'){st={use:'ink',idx:0,ans:{},ink:{},inkStep:'brand',help:hl,scope:sc};renderInk();return;}
      st={use:v,idx:0,ans:{},help:hl,scope:sc};renderStep();
    };
    reduce?go():setTimeout(go,200);
  }
  function goBack(){
    if(st.idx===0){ const sc=st.scope; st={use:null,idx:0,ans:{},help:st.help,scope:sc};
      if(sc&&SCOPES[sc]) renderScopeSelect(sc); else renderUseSelect(); }
    else {st.idx--;renderStep();}
  }
  function bind(){
    bodyEl.querySelectorAll('.fx-tile,.fx-pill').forEach(b=>b.addEventListener('click',()=>{ st.use===null?startUse(b.dataset.v):pick(b.dataset.v); }));
    const back=bodyEl.querySelector('.fx-back');if(back)back.addEventListener('click',goBack);
  }

  function openFinder(token){
    root.classList.add('on');root.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';
    if(token&&SCOPES[token]){ renderScopeSelect(token); return; }
    if(token&&(FLOWS[token]||token==='ink')){ st={use:null,idx:0,ans:{},help:st.help||'some'}; startUse(token); return; }
    const s=loadSaved();
    if(s&&s.done&&s.use==='ink'&&s.ink&&s.ink.model&&((INK[s.ink.brand]||{})[s.ink.range]||{})[s.ink.model]){st={use:'ink',idx:0,ans:{},ink:s.ink,inkStep:'result',help:s.help||'some'};renderInk();}
    else if(s&&s.done&&s.use&&FLOWS[s.use]){st={use:s.use,idx:FLOWS[s.use].length,ans:s.ans||{},help:s.help||'some'};renderResult();}
    else{st={use:null,idx:0,ans:{},help:(s&&s.help)||'some'};renderHelpSelect();}
  }
  function closeFinder(){root.classList.remove('on');root.setAttribute('aria-hidden','true');document.body.style.overflow='';}

  if(useTiles){
    useTiles.innerHTML=HERO.map(v=>`<button class="tile" data-v="${v}"><span class="ti">${I(GOAL[v].icon)}</span><span class="tx"><span class="tt">${GOAL[v].t}</span><span class="ts">${GOAL[v].s}</span></span></button>`).join('');
    useTiles.addEventListener('click',e=>{const b=e.target.closest('.tile');if(b)openFinder(b.dataset.v);});
  }
  document.addEventListener('click',e=>{const a=e.target.closest('a[href$="#finder"],[data-finder]');if(a){e.preventDefault();openFinder(a.dataset.finder||undefined);}});
  root.addEventListener('click',e=>{if(e.target.closest('[data-close]'))closeFinder();});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&root.classList.contains('on'))closeFinder();});

  const saved=loadSaved();
  if(saved&&saved.done){const fs=document.querySelector('#finder .fsub');if(fs)fs.innerHTML='Pick up where you left off, or start again — tell us what it\u2019s for and we\u2019ll match you.';}

  window.UbraFinder={open:openFinder,close:closeFinder};
})();
